// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T17:58:30.119Z
// Property: LakeHaus (ID: 6767906449166132)
// Collections: 91 amenities, 34 floorplans (live), 33 photos, 43 POIs, 4 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449166132",
  "property_external_id": "2109608",
  "property_zillow_url": "https://www.zillow.com/apartments/minneapolis-mn/lakehaus/5hJ5Qt/",
  "property_apartments_url": "https://www.apartments.com/lakehaus-minneapolis-mn/hkb5332/",
  "property_google_business_url": "https://www.google.com/maps/place/LakeHaus/data=!4m2!3m1!1s0x0:0x64238148d2943427?sa=X&ved=2ahUKEwi6jYyv7rmSAxV7JxAIHeW-CKMQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "4325685550",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "lake-haus",
  "property_name": "LakeHaus",
  "property_website_url": "https://www.lakehausapartmenthomes.com/",
  "property_domain": "https://www.lakehausapartmenthomes.com/",
  "property_address": "3100 West Lake Street",
  "property_full_address": "3100 W Lake St, Minneapolis, MN 55416",
  "property_address_1": "3100 W Lake St",
  "property_address_2": null,
  "property_address_city": "Minneapolis",
  "property_address_state": "MN",
  "property_address_zip_full": "55416",
  "property_address_zip": "55416",
  "property_address_country": "US",
  "property_address_county": "Hennepin County",
  "property_neighborhood_address": "Calhoun Isles",
  "property_address_latitude": "44.9491085",
  "property_address_longitude": "-93.318254",
  "property_email": "lakehaus@weidner.com",
  "property_phone": "(612) 416-6721",
  "property_call_tracking_phone": "612-416-6721",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Lake Haus, where contemporary living meets serene waterfront charm in Minneapolis, MN. Our thoughtfully designed one- and two-bedroom apartments boast luxurious amenities like a sparkling pool, state-of-the-art fitness center, and relaxing spa. Embrace vibrant community life with scenic walking trails and a pet-friendly park—your new adventure awaits!",
  "property_long_description": "<p>Come home to relaxed, elegant living at Lakehaus Apartments. Located directly on the Midtown Greenway, Lakehaus offers seamless bike commuting and immediate trail access to Bde Maka Ska and 50th &amp; France. Lakehaus offers modern apartments with sophisticated amenities in a warm and active community. It’s also pet-friendly, near the west metro, and provides unique condo-style layouts.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-241c-7209-bdff-4fa05f29b931.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with a large island, stainless steel appliances, and pendant lighting.",
    "public_id": "019d4935-241c-7209-bdff-4fa05f29b931",
    "storage_key": "property/6767906449166132/019d4935-241c-7209-bdff-4fa05f29b931.webp",
    "width": 2400,
    "height": 1600
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "200",
  "property_year_built": "2020",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "89",
  "property_admin_fee": "175",
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security deposit: $500",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "Varies",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://lakehausapartmenthomes.securecafe.com/onlineleasing/lakehaus0/floorplans.aspx",
  "property_resident_portal_url": "https://lakehausapartmenthomes.securecafenet.com/residentservices/lakehaus0/userlogin",
  "property_apply_now_url": "https://lakehausapartmenthomes.securecafe.com/onlineleasing/lakehaus0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-323e-75a9-ade4-a7244e3c7a98.webp",
  "property_primary_logo_media": {
    "alt_text": "Lake Haus MPLS MINN logo with crossed oars.",
    "public_id": "019d01ac-323e-75a9-ade4-a7244e3c7a98",
    "storage_key": "property/6767906449166132/019d01ac-323e-75a9-ade4-a7244e3c7a98.webp",
    "width": 1920,
    "height": 1103
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01b1-2ada-756c-aaad-fd5aba13456f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d01b1-2ada-756c-aaad-fd5aba13456f",
    "storage_key": "property/6767906449166132/019d01b1-2ada-756c-aaad-fd5aba13456f.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-323e-75a9-ade4-a7244e3c7a98.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Lake Haus MPLS MINN logo with crossed oars.",
    "public_id": "019d01ac-323e-75a9-ade4-a7244e3c7a98",
    "storage_key": "property/6767906449166132/019d01ac-323e-75a9-ade4-a7244e3c7a98.webp",
    "width": 1920,
    "height": 1103
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019f4254-a881-730e-be05-7d455b3b664e.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f4254-a881-730e-be05-7d455b3b664e",
    "storage_key": "property/6767906449166132/019f4254-a881-730e-be05-7d455b3b664e.webp",
    "width": 1280,
    "height": 735
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#28435d",
  "property_secondary_color": "#bbac94",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "526 - 1730",
  "property_sqft_min": "526",
  "property_sqft_max": "1730",
  "property_price_range": "1649 - 7926",
  "property_price_min": "1765",
  "property_price_max": "4485",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/LakeHausMpls",
  "property_instagram_url": "https://www.instagram.com/lakehausmpls/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJlX0bhWAn9ocRJzSU0kiBI2Q",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Lake Haus",
  "property_home_romance_title": "Embrace Your New Home, Where Comfort Meets Connection",
  "property_home_amenities_blurb": "Welcome to Lake Haus in vibrant Minneapolis, where modern living meets serene waterfront views. Our thoughtfully designed one and two-bedroom apartments offer luxurious features, from stainless steel appliances to spacious walk-in closets. Enjoy top-notch amenities, including a relaxing spa, fitness center, and scenic walking trails—all just steps from your door.",
  "property_home_floorplans_blurb": "Welcome to Lake Haus in vibrant Minneapolis, MN, where modern living meets lakeside charm. Our thoughtfully designed one and two-bedroom apartments offer the perfect blend of comfort and style. Unearth your ideal floor plan today—your dream home awaits just a few clicks away!",
  "property_home_gallery_blurb": "Welcome to Lake Haus in vibrant Minneapolis, MN, where luxurious living meets convenience. Choose from spacious one or two-bedroom floor plans, and indulge in top-notch amenities like a serene waterfront, a refreshing pool, and state-of-the-art fitness center. Picture yourself enjoying life here—your new home awaits!",
  "property_home_neighborhood_blurb": "Nestled in the vibrant heart of Minneapolis, Lake Haus offers spacious one and two-bedroom apartment floor plans, perfectly paired with a wealth of local attractions. Enjoy nearby cultural gems like the Minneapolis Institute of Art, serene lakeside parks, and the bustling Warehouse District. Experience city living at its finest!",
  "property_home_reviews_blurb": "At Lake Haus in Minneapolis, living feels like a luxurious retreat. With an exceptional team that makes you feel right at home, residents rave about our \"amazing management staff\" and \"top-notch\" amenities. Embrace a vibrant community life where you'll enjoy rooftop relaxation and unwind in style.",
  "property_neighborhood_blurb": "At Lake Haus, vibrant city life meets serene lakeside living in Minneapolis. Nestled near cultural gems like the Minneapolis Institute of Art, the scenic Edinborough Park, and the iconic U.S. Bank Stadium, our community offers an enriching neighborhood experience. See what's around our community and explore local favorites and nearby points of interest.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Lake Haus in vibrant Minneapolis, MN, upscale living meets convenience. Enjoy pristine pools, a state-of-the-art fitness center, and serene waterfront views. With thoughtfully designed floor plans featuring stainless steel appliances and walk-in closets, discover a lifestyle enriched by our resort-style amenities. Unwind at the spa or stroll our scenic trails!",
  "property_applynow_blurb": "At Lake Haus in vibrant Minneapolis, MN, our one- and two-bedroom apartments offer the perfect blend of comfort and luxury. Dive into our resort-style pool, energize in the fitness center, or unwind at the spa. With modern amenities like stainless steel appliances and walk-in closets, your dream home awaits—lease online today!",
  "property_contactus_blurb": "At Lake Haus in the heart of Minneapolis, we offer thoughtfully designed one and two-bedroom apartment floor plans tailored for your lifestyle. Whether you crave cozy or spacious living, we've got the perfect fit. Have questions? Contact our leasing team today and let's make Lake Haus your new home!",
  "property_faqs_blurb": "At Lake Haus in Minneapolis, MN, our thoughtfully designed one and two-bedroom apartments cater to your lifestyle. Curious about our community? Dive into our FAQs page, where clarity meets convenience and find answers to your burning questions—all in one place! Your new home awaits just a click away!",
  "property_floorplans_blurb": "At Lake Haus in vibrant Minneapolis, MN, your ideal living space awaits. Choose from our thoughtfully designed one-bedroom and two-bedroom floor plans, tailored to fit your lifestyle. Each home offers unique features and stunning views, making relaxation effortless. Browse our available apartment homes today and discover your perfect match!",
  "property_gallery_blurb": "At Lake Haus in vibrant Minneapolis, our photo gallery showcases the serene waterfront lifestyle you’ve always dreamed of. With spacious one and two-bedroom layouts, top-notch amenities like a pool, fitness center, and dog park, envision a community where luxury meets comfort. Picture yourself living here—your oasis awaits!",
  "property_interactivemap_blurb": "At Lake Haus in Minneapolis, your perfect home awaits amidst stunning waterfront views and modern amenities. Choose from spacious one- and two-bedroom floor plans featuring designer kitchens and serene balconies. With a fitness center, sauna, and dog park, every lifestyle is catered for. Check our interactive map for your new sanctuary!",
  "property_pets_blurb": "Nestled by the serene waters of Minneapolis, Lake Haus offers a vibrant community where comfort meets nature. Choose your perfect space for you and your furry friends—up to two pets are embraced here. Experience lakeside living with modern amenities and scenic views that make every day extraordinary.",
  "property_referafriend_blurb": "At Lake Haus in vibrant Minneapolis, our welcoming community invites you to enjoy spacious one- and two-bedroom floor plans designed for modern living. Share the experience! Great friends make great neighbors—refer a friend today and foster an incredible living environment together. Join us at Lake Haus for a new beginning!",
  "property_residentaccess_blurb": "Welcome to Lake Haus in vibrant Minneapolis, MN, where comfort meets style. Whether you're looking for a cozy one-bedroom or a spacious two-bedroom apartment, our thoughtfully designed floor plans cater to your lifestyle. Access your resident portal to manage rent payments, schedule maintenance, and enjoy seamless living today!",
  "property_reviews_blurb": "At Lake Haus, we embody the essence of a vibrant community where luxury meets warmth. Residents rave about our \"exceptional design,\" unmatched amenities, and the \"amazing management staff\" that makes living here feel like a five-star experience. Join us in Minneapolis and experience a home where every detail counts!",
  "property_created_at": "1752260571239",
  "property_scheduletour_blurb": "At Lake Haus in Minneapolis, MN, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Each space is crafted for modern living, providing a serene retreat. Curious about the community vibe? Hear firsthand from our residents and schedule your tour today!",
  "property_thankyou_blurb": "Thank you for reaching out to Lake Haus in vibrant Minneapolis! With our stylish one and two-bedroom floor plans, you'll find the perfect space to call home. Stay tuned as our team connects with you soon to share everything Lake Haus has to offer for your next exciting chapter!",
  "property_virtualtours_blurb": "Step into the serene ambiance of Lake Haus in Minneapolis, MN. Our thoughtfully designed one and two-bedroom apartment floor plans cater to every lifestyle. Immerse yourself in the charm of our community—take a virtual tour today and envision your new home beside the tranquil waters!",
  "property_copyright": "2025 All Rights Reserved. Lake Haus",
  "property_seo_title_home": "Lake Haus |  Apartments in Minneapolis, MN",
  "property_seo_description_home": "Experience life at Lake Haus in Minneapolis! Choose from spacious one or two-bedroom apartments with stunning amenities. Your perfect waterfront retreat awaits!",
  "property_seo_title_floorplans": "Floor Plans | Minneapolis, MN Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Lake Haus in Minneapolis! Browse our one and two-bedroom floor plans for a perfect fit that suits your lifestyle and needs.",
  "property_seo_title_amenities": "Amenities | Minneapolis, MN Apartments for Rent",
  "property_seo_description_amenities": "Experience lakeside living at Lake Haus in Minneapolis! Enjoy modern amenities like a pool, fitness center, and pet-friendly spaces. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Minneapolis, MN",
  "property_seo_description_gallery": "Experience luxury living at Lake Haus! Explore gorgeous waterfront apartments in Minneapolis with top-notch amenities. Discover your new dream home!",
  "property_seo_title_virtualtours": "Virtual Tours | Lake Haus Apartments",
  "property_seo_description_virtualtours": "Step inside Lake Haus in Minneapolis, MN! Experience stunning one- and two-bedroom apartments through our immersive virtual tour. Your ideal home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Lake Haus Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Lake Haus in Minneapolis! Use our interactive map to explore one and two-bedroom apartments with amazing amenities tailored for you.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Minneapolis, MN",
  "property_seo_description_neighborhood": "Experience the vibrant Minneapolis life at Lake Haus. Uncover local favorites and must-see spots that make our neighborhood a lively place to call home!",
  "property_seo_title_contact": "Contact Us | Lake Haus",
  "property_seo_description_contact": "Reach out to the Lake Haus team in Minneapolis for questions on our stylish one and two-bedroom plans. Your future home awaits—let us help you!",
  "property_seo_title_faqs": "FAQs | Apartments in Minneapolis, MN",
  "property_seo_description_faqs": "Unravel your queries at Lake Haus in Minneapolis! Our FAQs cover everything from amenities to floor plans. Get all the info you need for your ideal living experience.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Minneapolis, MN",
  "property_seo_description_reviews": "Discover life at Lake Haus, Minneapolis! See resident reviews and explore our pool, fitness center, and waterfront views for top-notch living.",
  "property_seo_title_applynow": "Apply Now | Apartments in Minneapolis, MN",
  "property_seo_description_applynow": "Experience lakeside living at Lake Haus in Minneapolis. Choose from stunning one or two-bedroom apartments, packed with amenities for a vibrant lifestyle. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Lake Haus",
  "property_seo_description_residentaccess": "Join Lake Haus in Minneapolis! Log into your resident portal for easy rent payments, maintenance requests, and convenience—all at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Lake Haus",
  "property_seo_description_referafriend": "Refer a friend to Lake Haus in Minneapolis! Great friends make great neighbors—share the charm and comfort of our community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Lake Haus",
  "property_seo_description_scheduletour": "Experience lakeside living at Lake Haus in Minneapolis, MN! Schedule your tour today and unveil your future home in our vibrant community.",
  "property_seo_title_privacy": "Privacy Policy | Lake Haus",
  "property_seo_description_privacy": "At Lake Haus in Minneapolis, your privacy matters. Learn how we protect your personal information and maintain a secure living environment. Read our policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Lake Haus",
  "property_seo_description_accessibility": "At Lake Haus in Minneapolis, we embrace digital inclusion. Our accessibility statement ensures all residents feel at home—online and offline. Join us!",
  "property_seo_title_sitemap": "Sitemap | Lake Haus",
  "property_seo_description_sitemap": "Navigate your way to comfort at Lake Haus in Minneapolis, MN. Check out our sitemap for seamless access to amenities, features, and community highlights!",
  "property_seo_title_thankyou": "Thank You | Lake Haus",
  "property_seo_description_thankyou": "Thank you for your interest in Lake Haus! A team member will reach out soon to help you find your perfect Minneapolis home by the water.",
  "property_seo_title_pets": "Pet Policy | Apartments in Minneapolis, MN",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293565268",
  "amenities": [
    {
      "id": "ec_1766f2a7f45e9053d01f4c0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "125033759",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d9a23-daf1-7373-8c28-68f326d1ef04.webp",
      "amenity_image_media": {
        "alt_text": "Spacious lounge area with large windows, modern furniture, and a dining table.",
        "public_id": "019d9a23-daf1-7373-8c28-68f326d1ef04",
        "storage_key": "property/6767906449166132/019d9a23-daf1-7373-8c28-68f326d1ef04.webp",
        "width": 2400,
        "height": 1601
      },
      "amenity_image_alt_text": "A modern living room with a large marble table and a long hallway.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c029bfea6ac9df3643ee7c7a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124754018",
      "title": "Furnish your apartment with CORT",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4b9ae815a108d082abe15b8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124753953",
      "title": "State-of-the-art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ab-fc1a-75a8-af03-c3e831f12cb0.webp",
      "amenity_image_media": {
        "alt_text": "Gym with weight racks, benches, rowing machine, and treadmills",
        "public_id": "019d01ab-fc1a-75a8-af03-c3e831f12cb0",
        "storage_key": "property/6767906449166132/019d01ab-fc1a-75a8-af03-c3e831f12cb0.webp",
        "width": 2400,
        "height": 1612
      },
      "amenity_image_alt_text": "A spacious gym with a variety of equipment including treadmills, weights, and exercise machines.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c4128fb0766e9efae944ad6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "125355751",
      "title": "8-foot 4-inch to 10-foot 4-inch Ceiling Heights",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b72bd5459d0984ffe801f4ca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124753955",
      "title": "Peloton Cycling + Yoga Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_520d1e430657749018164632",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124755862",
      "title": "Floor-to-Ceiling Pella Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ab-fc1e-75c1-8db3-12a0cd0f1d9a.webp",
      "amenity_image_media": {
        "alt_text": "Modern living room with a large blue sectional sofa, white coffee table, and floor-to-ceiling windows.",
        "public_id": "019d01ab-fc1e-75c1-8db3-12a0cd0f1d9a",
        "storage_key": "property/6767906449166132/019d01ab-fc1e-75c1-8db3-12a0cd0f1d9a.webp",
        "width": 2400,
        "height": 1601
      },
      "amenity_image_alt_text": "A living room with a large blue couch and a flat screen TV mounted on the wall.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a98bf880dd9de46a77dea86a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124753957",
      "title": "Locker Room + Sauna",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-00a5-77ae-a87f-3ac9b44f3b4e.webp",
      "amenity_image_media": {
        "alt_text": "Modern wooden sauna with large window overlooking city skyline.",
        "public_id": "019d01ac-00a5-77ae-a87f-3ac9b44f3b4e",
        "storage_key": "property/6767906449166132/019d01ac-00a5-77ae-a87f-3ac9b44f3b4e.webp",
        "width": 2400,
        "height": 1601
      },
      "amenity_image_alt_text": "A wooden sauna room with a view of the city outside the window.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc752bd9ff10223e454c303a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756876",
      "title": "Balconies with Gas Line*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e897ee7687c0b44da5255d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124753959",
      "title": "Private Outdoor Dog Park with Dog Walking Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-0973-745c-9a59-2e522d6f1fa6.webp",
      "amenity_image_media": {
        "alt_text": "Rooftop patio with string lights, a grill, seating, and artificial turf area with yoga mat.",
        "public_id": "019d01ac-0973-745c-9a59-2e522d6f1fa6",
        "storage_key": "property/6767906449166132/019d01ac-0973-745c-9a59-2e522d6f1fa6.webp",
        "width": 2400,
        "height": 1600
      },
      "amenity_image_alt_text": "A patio with a string of lights and a green lawn.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e09b87acb990a043bd35bfd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124753961",
      "title": "Pet-Friendly Community with On-Site Dog Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35a1ee33344aeba07481bb92",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756877",
      "title": "Roller Shades",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bace425f699ef8353015d32f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124753962",
      "title": "Bike Repair Shop",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_671e1906cfc7382cae05e2bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756879",
      "title": "GE Stainless Steel Appliances with Gas Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-0eaf-7284-8e27-70eaf115c63f.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with an island, stainless steel appliances, and pendant lights.",
        "public_id": "019d01ac-0eaf-7284-8e27-70eaf115c63f",
        "storage_key": "property/6767906449166132/019d01ac-0eaf-7284-8e27-70eaf115c63f.webp",
        "width": 2400,
        "height": 1601
      },
      "amenity_image_alt_text": "A modern kitchen with a white countertop and stainless steel appliances.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_868216ceb78b6f04af8ae72e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756880",
      "title": "Moen Fixtures & Faucets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7912cb2a5a65cdd906dfb7e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "125355633",
      "title": "Outdoor Bar with Fire Pit & Big Screen TV Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_505fb3b2637047b68fa3f7c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "125355634",
      "title": "Boutique Hotel-Style Lobby with Fireplace and Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_47c1abe6128f0c04fd17e216",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756882",
      "title": "Kitchen Islands*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6362b32edfde38acc1485045",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "125355635",
      "title": "Full Chef Quality Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d50fe7fe9397d529b1fc01b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756883",
      "title": "Wine Fridge*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ecbb8826e2d6627fa27f847",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756884",
      "title": "Oak Cabinetry with Slow Close Doors & Drawers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ebcad48af4c8bcf1c2f9f26",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "125355637",
      "title": "Terrace | Rooftop Pool & Hot Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a31e8c4842bd87f495a478c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "125355638",
      "title": "Terrace | Outdoor Dining with BBQ Grills & Firepits",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2561de2bff7adbb50457188b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756885",
      "title": "Under-Cabinet Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83905c2a6e18657c1e9bc8f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "125355639",
      "title": "Expansive Views Overlooking Lake Bde Maka Ska and Downtown",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dbe5d3c2e6d5cff007628e6b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756886",
      "title": "White Glass Subway Tile",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_447eeb3ee7cc5522d1dfb09e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "125355640",
      "title": "Exclusive Social Activities On-Site and Off-Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da5735f23ba13a11fb992829",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756887",
      "title": "White Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7dd7e519abc48c8e01357365",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756889",
      "title": "White-Wash Oak Hardwood Plank Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e66026ecb050130e72e73a0f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124754006",
      "title": "Work-from-Home Creative Coworking Space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d58e0ac3eaf0ba47b7ae7b9e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124754007",
      "title": "Controlled Access Heated Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6fca2d8e8a49e6223b5709a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756890",
      "title": "Repose Gray Wall Paint from Sherwin-Williams",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b5fb65266330e17e857d56bc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756892",
      "title": "Walk-in Closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd28f08c74a8b8149c80333d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756893",
      "title": "Bath Spas with Tile Showers & Glass Doors*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-13f9-744b-8990-8d08f85e4f77.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with double vanity, walk-in shower with marble tile.",
        "public_id": "019d01ac-13f9-744b-8990-8d08f85e4f77",
        "storage_key": "property/6767906449166132/019d01ac-13f9-744b-8990-8d08f85e4f77.webp",
        "width": 2400,
        "height": 1601
      },
      "amenity_image_alt_text": "A bathroom with a marble shower and white cabinetry.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_883ada886397cb0450a8e28a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124754009",
      "title": "Electronic Key Access Throughout Entire Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d1b41b53cc39481ed467501",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756895",
      "title": "Dual Bathroom Sinks*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0adabc4f07680f571db6229f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124754010",
      "title": "Guest Parking Via Skyway",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a8aa4ad8b6824f2a540cc7d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756897",
      "title": "Bathroom Pantry*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bdb6f014912a8b1079ddd803",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124754011",
      "title": "In-House Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ef5ffaab923a469220b263e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124754012",
      "title": "Electrical Vehicle Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa5cde09addcb82adaa0047d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756898",
      "title": "Split Bedroom Layout in Two-bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e49ee8b3cee30b55c378a96",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756900",
      "title": "Keyless Entry Door System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee0c152d72adab52d6e5fc0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124754013",
      "title": "On-Site Management Team",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c136d93ec503c03bac41589a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756901",
      "title": "Nest Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f703061cf4a3d943cfba811",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124754014",
      "title": "On-Site Temper Controlled Storage Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6aee2f0e1c8a374957b7b195",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756903",
      "title": "Gigabit Internet Service",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ab056de4d7482d406a94d64",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756904",
      "title": "In-home Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e3305fd42a06b4bb74d4468",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124754016",
      "title": "Secure Package Delivery Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f39c278ccc2c5316f029207a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756905",
      "title": "Luxury Heat Pump HVAC Systems Throughout",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0f45f5ce498bb2f65f7ee99",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124754017",
      "title": "Wi-Fi Access Throughout Common Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3dbdf0b184306c33b9b210a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756908",
      "title": "Customizable Technology Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a2ce6fece05d6b837a329a3f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "125355780",
      "title": "Elevated Move-in Experience",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b296c13d4ade4774e9edd1d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756940",
      "title": "Virtual Visits & Scheduled Appointments Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c94765b915a1917532094c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756941",
      "title": "Contactless Rent & Service Requests via our Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a3c2731025ba8ff318f7aca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "125355783",
      "title": "Enhanced Concierge Services",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_11dc6895f835702671015f43",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756912",
      "title": "North, East and West Facing Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06d4e15fee5f301d638c33be",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756947",
      "title": "Controlled Amenity Occupancy",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_471a7e2886dd4bb9afca0762",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756914",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3976b2cd6207b0957b892188",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756916",
      "title": "Extended Kitchen Island with Island Sink",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd91713dc0dc901f06c05ea5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756949",
      "title": "Silver LEED Certified",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc2548d3e37c41648d1ee3a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756952",
      "title": "Contact-free Package Pick Up",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a4d6a00d102ebddf105f189",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756918",
      "title": "Dual Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4f13456dd31e95e39a9413e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756919",
      "title": "Den / Sitting Room*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74bc0ba7828266ecf7f1a5c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756920",
      "title": "Single- or Double-Bedroom Walk-in Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_99c0abd2c820f3eea74ea850",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756921",
      "title": "Laundry Room with Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_292be2f0a3250ba630c6c5d1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756922",
      "title": "Wet Bar with Wine Fridge and Sink",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14b957ab60b02c262a767956",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756923",
      "title": "Powder Room*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_97d371c723b99b9d63c1913c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756924",
      "title": "Private Balcony in Primary Bedroom",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c5fab59a8e8fa96bca213404",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756926",
      "title": "Bathroom Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8a9279970027a3d99b8bbfc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756927",
      "title": "Dual Sink",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ddf7ee49ee0fc37de7f64f9d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756928",
      "title": "Bathtub Spa + Shower with Tile Surround & Glass Doors*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd7b40b1b5495f3dc462cf78",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756929",
      "title": "Sitting Room*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13ca5e5709ff30185a5f3f8c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756930",
      "title": "Fully Furnished",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_960471881e469c4f429bea05",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756931",
      "title": "Short Term Options Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8aec5fabfeea9bbbedef84b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756932",
      "title": "Floor to Ceiling Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_918944f25464da3c04db815e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756938",
      "title": "Full Size Washer and Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0657f263473650cb52e71d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124756939",
      "title": "State- Of-The-Art Amenities",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ef3af35e95471057d69d36b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "124754004",
      "title": "Expansive Views Overlooking Lake Bde Maka Ska and Downtown",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a12fc496178386816420e25",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "126741617",
      "title": "11 Ft Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5645d699fd17c878c26f3eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "126741620",
      "title": "Wheelchair Accessible",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f698c422f563fff1b61fad97",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "126741666",
      "title": "Corner Unit",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a489d1c0f04c17a35c769ee2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "126741673",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_941ccd11874c1572916d4260",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "126741674",
      "title": "Lake Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef6ef6d5c44c01a67e9825d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "126741675",
      "title": "Skyline Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28283455d1d2a21e2ed567ea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "126758502",
      "title": "1st Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d96a31b8a6df5b7b0fb4d997",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "126758504",
      "title": "2nd Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_455775c0c35e8e3013a698dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "126758508",
      "title": "3rd Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18e265f25e8cdb6538e028eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "126758511",
      "title": "4th Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_922065371d22877acb03e82f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "126758514",
      "title": "5th Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d526acc525709697decbfd0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "126758530",
      "title": "6th Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e12f48b9eea6eac93cc3704",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "126758539",
      "title": "7th Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_61ba032a9b8ca40e0164f8ca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "126758544",
      "title": "Top Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_35cc8b51374ff381d1968ee8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-241c-7209-bdff-4fa05f29b931.webp",
      "image_media": {
        "alt_text": "Modern kitchen with a large island, stainless steel appliances, and pendant lighting.",
        "public_id": "019d4935-241c-7209-bdff-4fa05f29b931",
        "storage_key": "property/6767906449166132/019d4935-241c-7209-bdff-4fa05f29b931.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large island with a sink, stainless steel appliances including a refrigerator and gas range, and elegant pendant lights.",
      "link": "false",
      "alt_text": "A modern kitchen with a large island and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(1).jpg"
    },
    {
      "id": "ec_122e1a9b2f22309ab4fba724",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019ddcec-1a16-746b-a161-07d405add129.webp",
      "image_media": {
        "alt_text": "Modern kitchen with large island, stainless steel appliances, and pendant lighting.",
        "public_id": "019ddcec-1a16-746b-a161-07d405add129",
        "storage_key": "property/6767906449166132/019ddcec-1a16-746b-a161-07d405add129.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring a spacious island with a deep sink, sleek cabinetry, and professional-grade appliances. Perfect for entertaining and everyday living.",
      "link": "false",
      "alt_text": "A modern kitchen with a stove top oven and a sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(2).jpg"
    },
    {
      "id": "ec_e73b9adcee2fc45c08113d2c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019ddcec-1a18-70a3-8ce5-b82f548d9404.webp",
      "image_media": {
        "alt_text": "Modern kitchen with a large island, double sink, professional gas range, and wine fridge.",
        "public_id": "019ddcec-1a18-70a3-8ce5-b82f548d9404",
        "storage_key": "property/6767906449166132/019ddcec-1a18-70a3-8ce5-b82f548d9404.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Experience gourmet cooking in this spacious and modern kitchen, featuring a large island with a double sink, a professional gas range, and a convenient wine fridge.",
      "link": "false",
      "alt_text": "A modern kitchen with a central island and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(3).jpg"
    },
    {
      "id": "ec_c7df6546349b320c90840baf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-159a-73e7-b125-2bef3da7ccec.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, bedside table, and en-suite bathroom.",
        "public_id": "019d4935-159a-73e7-b125-2bef3da7ccec",
        "storage_key": "property/6767906449166132/019d4935-159a-73e7-b125-2bef3da7ccec.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a comfortable queen-size bed with decorative pillows and a throw blanket. The adjacent bathroom is visible through an open doorway.",
      "link": "false",
      "alt_text": "A modern living room with a grey sofa and a kitchen area in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(4).jpg"
    },
    {
      "id": "ec_a67c1133e2761591b3577c9a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-15fe-748e-9184-1fae589e96e3.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a large sliding glass door opening to a balcony with a view.",
        "public_id": "019d4935-15fe-748e-9184-1fae589e96e3",
        "storage_key": "property/6767906449166132/019d4935-15fe-748e-9184-1fae589e96e3.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this stylish bedroom, complete with a plush bed, modern decor, and a private balcony offering scenic views.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and a mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(5).jpg"
    },
    {
      "id": "ec_9fea75eb2eb074b49c5731a1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-14d9-74be-bb1c-a030a7a3233d.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with a navy sectional sofa and a large island.",
        "public_id": "019d4935-14d9-74be-bb1c-a030a7a3233d",
        "storage_key": "property/6767906449166132/019d4935-14d9-74be-bb1c-a030a7a3233d.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area featuring a large navy sectional sofa, marble coffee table, and a sleek modern kitchen with stainless steel appliances and a breakfast bar.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and a view of the outdoors through a sliding glass door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(6).jpg"
    },
    {
      "id": "ec_cef5c82df0522196fbd9699f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-1423-71f4-87cd-c87d8079b9f5.webp",
      "image_media": {
        "alt_text": "Modern wet bar with white cabinets, herringbone backsplash, and wine fridge.",
        "public_id": "019d4935-1423-71f4-87cd-c87d8079b9f5",
        "storage_key": "property/6767906449166132/019d4935-1423-71f4-87cd-c87d8079b9f5.webp",
        "width": 1601,
        "height": 2400
      },
      "title": "Apartment",
      "description": "A stylish wet bar featuring ample cabinet storage, a sleek sink, a built-in wine refrigerator, and a contemporary herringbone tile backsplash.",
      "link": "false",
      "alt_text": "A modern living room with a blue sofa and a coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(7).jpg"
    },
    {
      "id": "ec_cc94efc926812551de079b80",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-3d2f-74a6-b88a-f827f17e7454.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, large mirror, and walk-in shower.",
        "public_id": "019d4935-3d2f-74a6-b88a-f827f17e7454",
        "storage_key": "property/6767906449166132/019d4935-3d2f-74a6-b88a-f827f17e7454.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a double vanity with ample storage, a spacious walk-in shower with marble tile, and a large framed mirror.",
      "link": "false",
      "alt_text": "A bathroom with a marble shower and white cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(8).jpg"
    },
    {
      "id": "ec_12ffcdb6e56424293cc181dc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-13f9-744b-8990-8d08f85e4f77.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, walk-in shower with marble tile.",
        "public_id": "019d01ac-13f9-744b-8990-8d08f85e4f77",
        "storage_key": "property/6767906449166132/019d01ac-13f9-744b-8990-8d08f85e4f77.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Apartment",
      "description": "Luxurious bathroom featuring a spacious walk-in shower with marble tile and a sleek double vanity with ample counter space.",
      "link": "false",
      "alt_text": "A bathroom with a marble shower and white cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(9).jpg"
    },
    {
      "id": "ec_869c743b06de570383377c44",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-41d6-71e5-9533-49d181009f3a.webp",
      "image_media": {
        "alt_text": "Washer and dryer set in a laundry room with sink and cabinets.",
        "public_id": "019d4935-41d6-71e5-9533-49d181009f3a",
        "storage_key": "property/6767906449166132/019d4935-41d6-71e5-9533-49d181009f3a.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A spacious laundry room featuring a stainless steel washer and dryer set, a deep sink, and ample cabinet storage.",
      "link": "false",
      "alt_text": "A laundry room with a washer and dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(10).jpg"
    },
    {
      "id": "ec_8a9a92edb35b4852bbb7eff9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-42f2-70bd-983a-28cfeacb6f7c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and bar stools, adjacent dining area with table and chairs, and living room with blue sofa.",
        "public_id": "019d4935-42f2-70bd-983a-28cfeacb6f7c",
        "storage_key": "property/6767906449166132/019d4935-42f2-70bd-983a-28cfeacb6f7c.webp",
        "width": 2400,
        "height": 1588
      },
      "title": "Apartment",
      "description": "Experience elegant living with a spacious open-concept kitchen, dining, and living area. Perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "A modern kitchen with a dining table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(11).jpg"
    },
    {
      "id": "ec_b44534ad45ac3a9e47281fd0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-4557-7368-8846-0ca1f4bcce6c.webp",
      "image_media": {
        "alt_text": "Modern communal lounge with a fireplace, comfortable seating, and a wet bar in the background.",
        "public_id": "019d4935-4557-7368-8846-0ca1f4bcce6c",
        "storage_key": "property/6767906449166132/019d4935-4557-7368-8846-0ca1f4bcce6c.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish communal lounge, featuring a cozy fireplace and ample seating. Perfect for socializing or enjoying a quiet moment.",
      "link": "false",
      "alt_text": "A white bathroom with a marble shower and a large mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(12).jpg"
    },
    {
      "id": "ec_645dc906f072b3c0e10a27b8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-480d-7095-8bd9-929812f1e6d5.webp",
      "image_media": {
        "alt_text": "Modern communal kitchen area with large live-edge table, bar stools, and coffee station.",
        "public_id": "019d4935-480d-7095-8bd9-929812f1e6d5",
        "storage_key": "property/6767906449166132/019d4935-480d-7095-8bd9-929812f1e6d5.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Community",
      "description": "Enjoy the convenience of a fully-equipped communal kitchen, perfect for casual gatherings or a morning coffee break.",
      "link": "false",
      "alt_text": "A modern kitchen with wooden floors and a large island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(13).jpg"
    },
    {
      "id": "ec_823b30f8bee92d2f8e2c24df",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-64f6-7558-8bfe-261a7a4ffd06.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with live edge wood countertop and stylish chairs.",
        "public_id": "019d4935-64f6-7558-8bfe-261a7a4ffd06",
        "storage_key": "property/6767906449166132/019d4935-64f6-7558-8bfe-261a7a4ffd06.webp",
        "width": 1600,
        "height": 2400
      },
      "title": "Apartment",
      "description": "Stylish kitchen island featuring a live edge wood countertop, complemented by modern chairs and minimalist shelving.",
      "link": "false",
      "alt_text": "A modern kitchen with a large island and wooden floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(14).jpg"
    },
    {
      "id": "ec_0f43b9b2ebc82dcd8ad47a97",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-6ebf-72ad-8478-f7f2cc472d00.webp",
      "image_media": {
        "alt_text": "Interior hallway of a self-storage facility with rows of white roll-up doors.",
        "public_id": "019d4935-6ebf-72ad-8478-f7f2cc472d00",
        "storage_key": "property/6767906449166132/019d4935-6ebf-72ad-8478-f7f2cc472d00.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Community",
      "description": "Secure and clean self-storage units available in various sizes to meet your needs.",
      "link": "false",
      "alt_text": "A room with a carpeted floor and a sliding door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(15).jpg"
    },
    {
      "id": "ec_a3e1350ed4803d8388dee987",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-71e0-73f1-9676-f37106830e2a.webp",
      "image_media": {
        "alt_text": "Electric vehicle charging stations in a parking garage.",
        "public_id": "019d4935-71e0-73f1-9676-f37106830e2a",
        "storage_key": "property/6767906449166132/019d4935-71e0-73f1-9676-f37106830e2a.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Community",
      "description": "Charge your electric vehicle conveniently with our on-site charging stations located in the parking garage.",
      "link": "false",
      "alt_text": "A balcony with a black railing and a view of a snowy landscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(16).jpg"
    },
    {
      "id": "ec_4c3529f6f11b6c5f9c0f944b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-7490-733a-ab13-265855b45e81.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with weightlifting equipment and cardio machines.",
        "public_id": "019d4935-7490-733a-ab13-265855b45e81",
        "storage_key": "property/6767906449166132/019d4935-7490-733a-ab13-265855b45e81.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide array of cardio machines and free weights for a complete workout.",
      "link": "false",
      "alt_text": "A modern living room with a fireplace and comfortable seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(17).jpg"
    },
    {
      "id": "ec_192c850596217a2dce4bb3a1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ab-fc1a-75a8-af03-c3e831f12cb0.webp",
      "image_media": {
        "alt_text": "Gym with weight racks, benches, rowing machine, and treadmills",
        "public_id": "019d01ab-fc1a-75a8-af03-c3e831f12cb0",
        "storage_key": "property/6767906449166132/019d01ab-fc1a-75a8-af03-c3e831f12cb0.webp",
        "width": 2400,
        "height": 1612
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring weightlifting equipment, cardio machines, and ample space for workouts.",
      "link": "false",
      "alt_text": "A modern kitchen with a bar area and a dining table set for four.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(18).jpg"
    },
    {
      "id": "ec_72c03d4669b7226485e28976",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-84fe-751f-90f6-a6ab7f470dd9.webp",
      "image_media": {
        "alt_text": "Modern gym with cardio machines, weight racks, and large windows overlooking the city.",
        "public_id": "019d4935-84fe-751f-90f6-a6ab7f470dd9",
        "storage_key": "property/6767906449166132/019d4935-84fe-751f-90f6-a6ab7f470dd9.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center offers a variety of cardio equipment, free weights, and strength training machines for a complete workout.",
      "link": "false",
      "alt_text": "A modern living room with a stone fireplace and wooden furniture.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(19).jpg"
    },
    {
      "id": "ec_85d32f2cb3f00dbe4cafaa1d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-92fe-76e7-854f-767846093c6d.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with grills and fire pit, next to a green lawn with cornhole boards.",
        "public_id": "019d4935-92fe-76e7-854f-767846093c6d",
        "storage_key": "property/6767906449166132/019d4935-92fe-76e7-854f-767846093c6d.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Community",
      "description": "Enjoy our outdoor lounge area with grills, fire pits, and games, perfect for socializing and relaxing.",
      "link": "false",
      "alt_text": "A modern waiting room with a mix of brown and white furniture.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(20).jpg"
    },
    {
      "id": "ec_bb9816b0ae39fc5b24476e31",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-9a0f-7678-87e8-cb7ca8001f4b.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with sectional sofas, coffee tables, and a built-in entertainment center.",
        "public_id": "019d4935-9a0f-7678-87e8-cb7ca8001f4b",
        "storage_key": "property/6767906449166132/019d4935-9a0f-7678-87e8-cb7ca8001f4b.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge, featuring comfortable seating, a TV, and a sleek entertainment center, perfect for gatherings.",
      "link": "false",
      "alt_text": "A modern kitchen with a wooden table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(21).jpg"
    },
    {
      "id": "ec_0c6693ed49d000098d409da8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-9f89-768c-9a53-baea5384c593.webp",
      "image_media": {
        "alt_text": "Outdoor patio with seating and dining areas, featuring a fireplace and string lights.",
        "public_id": "019d4935-9f89-768c-9a53-baea5384c593",
        "storage_key": "property/6767906449166132/019d4935-9f89-768c-9a53-baea5384c593.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Community",
      "description": "Enjoy the beautifully appointed outdoor community spaces, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "A long hallway with doors on both sides.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(22).jpg"
    },
    {
      "id": "ec_718a97d6b36bf48115258105",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-a766-7783-9aae-a99a5b3944ec.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with string lights, seating, tables, grills, and a hot tub.",
        "public_id": "019d4935-a766-7783-9aae-a99a5b3944ec",
        "storage_key": "property/6767906449166132/019d4935-a766-7783-9aae-a99a5b3944ec.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Community",
      "description": "Enjoy elevated living with our rooftop lounge, complete with comfortable seating, outdoor grills, a hot tub, and stunning city views.",
      "link": "false",
      "alt_text": "Two electric vehicle charging stations are installed on a wall in a parking garage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(23).jpg"
    },
    {
      "id": "ec_0dec1042652e2ee83af0198c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-b1e6-7689-93af-95ec9f60796c.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with a hot tub, outdoor kitchen, dining table, and city views.",
        "public_id": "019d4935-b1e6-7689-93af-95ec9f60796c",
        "storage_key": "property/6767906449166132/019d4935-b1e6-7689-93af-95ec9f60796c.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Community",
      "description": "Enjoy the rooftop amenities including a relaxing hot tub, outdoor kitchen with grill, and comfortable seating areas perfect for entertaining.",
      "link": "false",
      "alt_text": "A modern gym with a glass wall and a television.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(24).jpg"
    },
    {
      "id": "ec_0c3cff03ff6997bab338c1cd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-c375-7079-8bb5-b5eff0f7727c.webp",
      "image_media": {
        "alt_text": "Rooftop swimming pool and hot tub with lounge chairs and cabanas.",
        "public_id": "019d4935-c375-7079-8bb5-b5eff0f7727c",
        "storage_key": "property/6767906449166132/019d4935-c375-7079-8bb5-b5eff0f7727c.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Community",
      "description": "Enjoy the resort-style rooftop pool and spa, perfect for relaxation and soaking up the sun.",
      "link": "false",
      "alt_text": "A spacious gym with a variety of equipment including treadmills, weights, and exercise machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(25).jpg"
    },
    {
      "id": "ec_db268c14c948c46fd4a6852e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-84fe-751f-90f6-a6ab7f470dd9.webp",
      "image_media": {
        "alt_text": "Modern gym with cardio machines, weight racks, and large windows overlooking the city.",
        "public_id": "019d4935-84fe-751f-90f6-a6ab7f470dd9",
        "storage_key": "property/6767906449166132/019d4935-84fe-751f-90f6-a6ab7f470dd9.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center offers a variety of cardio equipment, free weights, and strength training machines for a complete workout.",
      "link": "false",
      "alt_text": "A gym with treadmills, elliptical machines, and other exercise equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(26).jpg"
    },
    {
      "id": "ec_a95917e6a914cc73765786e8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-92fe-76e7-854f-767846093c6d.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with grills and fire pit, next to a green lawn with cornhole boards.",
        "public_id": "019d4935-92fe-76e7-854f-767846093c6d",
        "storage_key": "property/6767906449166132/019d4935-92fe-76e7-854f-767846093c6d.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Community",
      "description": "Enjoy our outdoor lounge area with grills, fire pits, and games, perfect for socializing and relaxing.",
      "link": "false",
      "alt_text": "A modern apartment complex with a grassy courtyard and seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(27).jpg"
    },
    {
      "id": "ec_f55835c19fa941d14e7e3fbf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-9a0f-7678-87e8-cb7ca8001f4b.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with sectional sofas, coffee tables, and a built-in entertainment center.",
        "public_id": "019d4935-9a0f-7678-87e8-cb7ca8001f4b",
        "storage_key": "property/6767906449166132/019d4935-9a0f-7678-87e8-cb7ca8001f4b.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge, featuring comfortable seating, a TV, and a sleek entertainment center, perfect for gatherings.",
      "link": "false",
      "alt_text": "A patio with a TV and couches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(28).jpg"
    },
    {
      "id": "ec_23296f18a54f831dc8168a4a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-9f89-768c-9a53-baea5384c593.webp",
      "image_media": {
        "alt_text": "Outdoor patio with seating and dining areas, featuring a fireplace and string lights.",
        "public_id": "019d4935-9f89-768c-9a53-baea5384c593",
        "storage_key": "property/6767906449166132/019d4935-9f89-768c-9a53-baea5384c593.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Community",
      "description": "Enjoy the beautifully appointed outdoor community spaces, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "A patio with tables and chairs is surrounded by apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(29).jpg"
    },
    {
      "id": "ec_206197f6117f8c581f31bc4c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-64f6-7558-8bfe-261a7a4ffd06.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with live edge wood countertop and stylish chairs.",
        "public_id": "019d4935-64f6-7558-8bfe-261a7a4ffd06",
        "storage_key": "property/6767906449166132/019d4935-64f6-7558-8bfe-261a7a4ffd06.webp",
        "width": 1600,
        "height": 2400
      },
      "title": "Apartment",
      "description": "Stylish kitchen island featuring a live edge wood countertop, complemented by modern chairs and minimalist shelving.",
      "link": "false",
      "alt_text": "A rooftop patio with a table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(30).jpg"
    },
    {
      "id": "ec_041df3fe1278f7bde7e1ee9a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-b1e6-7689-93af-95ec9f60796c.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with a hot tub, outdoor kitchen, dining table, and city views.",
        "public_id": "019d4935-b1e6-7689-93af-95ec9f60796c",
        "storage_key": "property/6767906449166132/019d4935-b1e6-7689-93af-95ec9f60796c.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Community",
      "description": "Enjoy the rooftop amenities including a relaxing hot tub, outdoor kitchen with grill, and comfortable seating areas perfect for entertaining.",
      "link": "false",
      "alt_text": "A modern building with a pool in the foreground and a tall building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(31).jpg"
    },
    {
      "id": "ec_532900cd14f59270cc42d06e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d4935-c375-7079-8bb5-b5eff0f7727c.webp",
      "image_media": {
        "alt_text": "Rooftop swimming pool and hot tub with lounge chairs and cabanas.",
        "public_id": "019d4935-c375-7079-8bb5-b5eff0f7727c",
        "storage_key": "property/6767906449166132/019d4935-c375-7079-8bb5-b5eff0f7727c.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Community",
      "description": "Enjoy the resort-style rooftop pool and spa, perfect for relaxation and soaking up the sun.",
      "link": "false",
      "alt_text": "A large outdoor swimming pool with a slide and a hot tub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_LakeHaus_Favorites%20(32).jpg"
    },
    {
      "id": "ec_17ae035ede3f52cc5c05531d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/01a0d21b-8bd0-72bf-85f3-6fac5bb41086.webp",
      "image_media": {
        "alt_text": "Rooftop terrace with dining tables, grills, and lounge seating overlooking a lake.",
        "public_id": "01a0d21b-8bd0-72bf-85f3-6fac5bb41086",
        "storage_key": "property/6767906449166132/01a0d21b-8bd0-72bf-85f3-6fac5bb41086.webp",
        "width": 2400,
        "height": 1601
      },
      "title": "Community",
      "description": "Enjoy breathtaking lake views from our expansive rooftop terrace, complete with outdoor dining, grilling stations, and comfortable lounge areas.",
      "link": "false",
      "alt_text": "A rooftop patio with a view of the water and a sky full of clouds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/LakeHaus_Rooftop%20Patio_Day_006.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_4eb242af-f252-44be-a750-5833102bb9bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Hen House Eatery",
      "poi_type": "Restaurants",
      "poi_address": "114 S 8th St, Minneapolis, MN 55402, USA",
      "poi_short_description": "Sprawling cafe offering classic, locally sourced breakfast and lunch, plus wine and happy hour.",
      "poi_long_description": "People say this restaurant serves delicious cinnamon rolls, omelets, and hash browns, and offers a wide variety of breakfast and lunch options, including vegan and vegetarian choices. They highlight the generous portions, fresh ingredients, and homemade jam, as well as the fun, diner-style atmosphere. They also like the fast and friendly service, and the attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-b38d-77b4-bdfd-08278b7c21a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-b38d-77b4-bdfd-08278b7c21a7",
        "storage_key": "property/6767906449166132/019d01ac-b38d-77b4-bdfd-08278b7c21a7.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://henhouseeatery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15909638786371344658&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "hen-house-eatery",
      "poi_latitude": "44.9750527",
      "poi_longitude": "-93.2706235",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 612-345-4664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f7a9-748e-91a3-696e2aec13a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-f7a9-748e-91a3-696e2aec13a8",
        "storage_key": "property/6767906449166132/019d01ac-f7a9-748e-91a3-696e2aec13a8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr03h2Jkys1IREtlw7i5kytw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_6b04df81-0d87-4ed8-8042-5897116ae0d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Hell's Kitchen Inc.",
      "poi_type": "Restaurants",
      "poi_address": "80 S 9th St, Minneapolis, MN 55402, USA",
      "poi_short_description": "American comfort fare including Hell's Kitchen Bloody Marys served in a casual setting with a fireplace and a candy-themed room.",
      "poi_long_description": "People say this restaurant serves delicious lemon ricotta pancakes, huevos rancheros, and French dip sandwiches. They also highlight the fun atmosphere, live music, and the impressive Bloody Mary and mimosa bars.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-b31c-72a9-b28f-16fba0cc0d9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-b31c-72a9-b28f-16fba0cc0d9b",
        "storage_key": "property/6767906449166132/019d01ac-b31c-72a9-b28f-16fba0cc0d9b.webp",
        "width": 841,
        "height": 841
      },
      "poi_business_url": "http://www.hellskitcheninc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5204213648483518744&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "hells-kitchen-inc",
      "poi_latitude": "44.97474159999999",
      "poi_longitude": "-93.2729987",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 612-332-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f7a9-748e-91a3-696e2aec13a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-f7a9-748e-91a3-696e2aec13a8",
        "storage_key": "property/6767906449166132/019d01ac-f7a9-748e-91a3-696e2aec13a8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpcQ6D5cys1IRGIkZfb0UOUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_aa2b64fb-9f0c-41f1-849e-38b074d45dea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Gai Noi",
      "poi_type": "Restaurants",
      "poi_address": "1610 Harmon Pl, Minneapolis, MN 55403, USA",
      "poi_short_description": "Thai fixture featuring modern cuisine, family-style dining and a rooftop patio.",
      "poi_long_description": "People say this Laotian restaurant serves delicious basil wings, crispy fried tofu, and drunken udon noodles. They also highlight the beautiful atrium, rooftop patio, and friendly staff.\n\nOther reviews mention the food can be spicy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-b433-7009-a32a-a3f4f4508348.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-b433-7009-a32a-a3f4f4508348",
        "storage_key": "property/6767906449166132/019d01ac-b433-7009-a32a-a3f4f4508348.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.gainoimpls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8791079662501712614&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "gai-noi",
      "poi_latitude": "44.97159389999999",
      "poi_longitude": "-93.28545830000002",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f7a9-748e-91a3-696e2aec13a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-f7a9-748e-91a3-696e2aec13a8",
        "storage_key": "property/6767906449166132/019d01ac-f7a9-748e-91a3-696e2aec13a8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwZlh67Uzs1IR5lKTO2AwAHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_db48fe50-6c7a-4427-81b0-10aa3c5e8387",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Matt's Bar and Grill",
      "poi_type": "Restaurants",
      "poi_address": "3500 Cedar Ave, Minneapolis, MN 55407, USA",
      "poi_short_description": "Retro, no-frills venue for juicy burgers stuffed with cheese as well as fries, beer and other classic fare.",
      "poi_long_description": "People say this hamburger restaurant serves delicious Juicy Lucy burgers and fries. They highlight the casual, old-school atmosphere and the friendly staff. They also like the fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-b40c-77bc-a808-1df3ed9bf043.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-b40c-77bc-a808-1df3ed9bf043",
        "storage_key": "property/6767906449166132/019d01ac-b40c-77bc-a808-1df3ed9bf043.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mattsbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9006365263169826518&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "matts-bar-and-grill",
      "poi_latitude": "44.9394256",
      "poi_longitude": "-93.2476485",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 612-722-7072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f7a9-748e-91a3-696e2aec13a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-f7a9-748e-91a3-696e2aec13a8",
        "storage_key": "property/6767906449166132/019d01ac-f7a9-748e-91a3-696e2aec13a8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgzapGhIo9ocR1q6nNH0J_Xw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_47616bfa-5ecc-42d0-bd05-16c7a24011e7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "2715 Southdale Ctr, Edina, MN 55435, USA",
      "poi_short_description": "Upscale chain eatery offering a broad American menu and a huge selection of cheesecakes.",
      "poi_long_description": "People say this restaurant serves delicious cheesecake, burgers, and pasta. They also highlight the generous portions, friendly staff, and vibrant atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-b85f-7454-bfe9-45614c1889ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-b85f-7454-bfe9-45614c1889ea",
        "storage_key": "property/6767906449166132/019d01ac-b85f-7454-bfe9-45614c1889ea.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/mn/edina-53.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=17006576159862361956&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "44.87939679999999",
      "poi_longitude": "-93.3252193",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 952-653-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f7a9-748e-91a3-696e2aec13a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-f7a9-748e-91a3-696e2aec13a8",
        "storage_key": "property/6767906449166132/019d01ac-f7a9-748e-91a3-696e2aec13a8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXwvcAaQm9ocRZA85pul-A-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ab147222-4ee4-4994-8200-005bf1bd18e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Karmel Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2910 Pleasant Ave, Minneapolis, MN 55408, USA",
      "poi_short_description": "Mall featuring clothing stores, along with a mosque and Somali food stalls.",
      "poi_long_description": "People say this shopping center offers a wide variety of clothing, electronics, food, and shipping services, catering to the East African community. They also highlight the welcoming environment, the hardworking and community-focused businesses, and the beautiful traditional clothing and jewelry.\n\nOther reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-b85e-707a-b229-d528667788bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-b85e-707a-b229-d528667788bc",
        "storage_key": "property/6767906449166132/019d01ac-b85e-707a-b229-d528667788bc.webp",
        "width": 949,
        "height": 1265
      },
      "poi_business_url": "https://karmelmall.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10963666975832638846&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "karmel-mall",
      "poi_latitude": "44.9497937",
      "poi_longitude": "-93.2816161",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 612-517-5517",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f7a9-748e-91a3-6da140d9876c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-f7a9-748e-91a3-6da140d9876c",
        "storage_key": "property/6767906449166132/019d01ac-f7a9-748e-91a3-6da140d9876c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjx60uYsn9ocRfoUvygbFJpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f8d4760d-d062-4678-b103-cada07aaddc2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Ridgedale Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "12401 Wayzata Blvd, Minnetonka, MN 55305, USA",
      "poi_short_description": "Clean, modern, indoor center featuring anchor retailers, eateries and a play area.",
      "poi_long_description": "Bi-level mall with department stores, brand-name retailers & casual eateries, plus a play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-b9b8-77d2-90eb-e6c44ba650c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-b9b8-77d2-90eb-e6c44ba650c6",
        "storage_key": "property/6767906449166132/019d01ac-b9b8-77d2-90eb-e6c44ba650c6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ridgedalecenter.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4970908271431737421&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "ridgedale-center",
      "poi_latitude": "44.9681006",
      "poi_longitude": "-93.4375487",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 952-252-2801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f7a9-748e-91a3-6da140d9876c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-f7a9-748e-91a3-6da140d9876c",
        "storage_key": "property/6767906449166132/019d01ac-f7a9-748e-91a3-6da140d9876c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyYOEwJRKs1IRTWC9Ybw2_EQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_66262f0e-109a-436d-93af-9792633bd4bc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "721 Washington Ave S Ste 101, Minneapolis, MN 55415, USA",
      "poi_short_description": "Neighborhood grocery chain selling specialty and organic products, plus wine, beer, and spirits.",
      "poi_long_description": "People say this grocery store offers a wide selection of unique, high-quality private-label products, including hummus, fully cooked chicken, and Asiago bagels. They highlight the convenient location, with easy access via public transportation and a dedicated parking area, and the spacious layout with wide aisles. They also like the friendly and helpful staff, and the separate liquor store with a variety of non-alcoholic beers and single cans.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-ba73-75c9-9de0-5f5f4f043e73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-ba73-75c9-9de0-5f5f4f043e73",
        "storage_key": "property/6767906449166132/019d01ac-ba73-75c9-9de0-5f5f4f043e73.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/mn/minneapolis/725/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16979149607654630503&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "44.9770795",
      "poi_longitude": "-93.2576736",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 612-339-2110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f7f7-7689-9741-4316b85aca85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-f7f7-7689-9741-4316b85aca85",
        "storage_key": "property/6767906449166132/019d01ac-f7f7-7689-9741-4316b85aca85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7Bfsxcts1IRZ6R32JsOous",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a605009c-bddb-4d75-8bdd-dffb15bb26b2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Southdale Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "10 Southdale Ctr, Edina, MN 55435, USA",
      "poi_short_description": "Enclosed shopping center featuring a theater, an arcade and a variety of chain stores.",
      "poi_long_description": "People say this shopping center offers delicious food and cheesecake at The Cheesecake Factory. They also highlight the convenient location, spacious layout, and beautiful design.\n\nOther reviews mention the restrooms can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-bd6f-76a4-8ba4-a3aa3e9e4346.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-bd6f-76a4-8ba4-a3aa3e9e4346",
        "storage_key": "property/6767906449166132/019d01ac-bd6f-76a4-8ba4-a3aa3e9e4346.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.simon.com/mall/southdale-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14994194372892663474&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "southdale-center",
      "poi_latitude": "44.8806729",
      "poi_longitude": "-93.3250163",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 952-925-7885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f7a9-748e-91a3-6da140d9876c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-f7a9-748e-91a3-6da140d9876c",
        "storage_key": "property/6767906449166132/019d01ac-f7a9-748e-91a3-6da140d9876c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmSzCV6Ym9ocRsp5t6VYUFtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a4f20106-c881-4716-91d4-be7c0f9f7bd0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "222 Hennepin Ave, Minneapolis, MN 55401, USA",
      "poi_short_description": "Market offering natural and organic products, plus healthy prepared foods.",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-bdad-7589-a2f8-1d43bb758def.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-bdad-7589-a2f8-1d43bb758def",
        "storage_key": "property/6767906449166132/019d01ac-bdad-7589-a2f8-1d43bb758def.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/hennepin?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=1570021031660216664&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "44.98273289999999",
      "poi_longitude": "-93.2693518",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 612-313-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f7f7-7689-9741-4316b85aca85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-f7f7-7689-9741-4316b85aca85",
        "storage_key": "property/6767906449166132/019d01ac-f7f7-7689-9741-4316b85aca85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTKP34Qys1IRWOH_Wc_VyRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d3f608c6-bb80-422a-964d-dd80f0c32226",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "University of Minnesota",
      "poi_type": "Education",
      "poi_address": "Minneapolis, MN 55455, USA",
      "poi_short_description": "The Mississippi River bisects this urban research university known for management, education & law.",
      "poi_long_description": "The Mississippi River bisects this urban research university known for management, education & law.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-bed0-712f-9b87-0f9e49ca11e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-bed0-712f-9b87-0f9e49ca11e3",
        "storage_key": "property/6767906449166132/019d01ac-bed0-712f-9b87-0f9e49ca11e3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://twin-cities.umn.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16362166377837992312&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "university-of-minnesota",
      "poi_latitude": "44.97399",
      "poi_longitude": "-93.2277285",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 612-625-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f7d7-7708-ae05-5456914cea0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-f7d7-7708-ae05-5456914cea0e",
        "storage_key": "property/6767906449166132/019d01ac-f7d7-7708-ae05-5456914cea0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_8cK92kts1IReJnfUqEXEuM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_fe29088c-886e-415b-aec2-9a00e1ea7a19",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Minneapolis Central Library",
      "poi_type": "Education",
      "poi_address": "300 Nicollet Mall, Minneapolis, MN 55401, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this public library offers a wide variety of resources, including books, movies, computers, and study rooms, and they appreciate the helpful staff and comfortable atmosphere. They also highlight the library's beautiful building, convenient location, and community events.\n\nSome reviews mention the library can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-bed6-7598-9470-687b5e8d4761.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-bed6-7598-9470-687b5e8d4761",
        "storage_key": "property/6767906449166132/019d01ac-bed6-7598-9470-687b5e8d4761.webp",
        "width": 1156,
        "height": 1280
      },
      "poi_business_url": "https://www.hclib.org/about/locations/minneapolis-central",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713452121897218264&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "minneapolis-central-library",
      "poi_latitude": "44.98060599999999",
      "poi_longitude": "-93.2699584",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 612-543-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f7d7-7708-ae05-5456914cea0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-f7d7-7708-ae05-5456914cea0e",
        "storage_key": "property/6767906449166132/019d01ac-f7d7-7708-ae05-5456914cea0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ64ilwZoys1IR2LAO_Ylm7Hg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_9fab0dbc-329d-43c2-822e-e1a36dad19e7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Minneapolis College",
      "poi_type": "Education",
      "poi_address": "1501 Hennepin Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-c245-76f4-8bcd-56f95763a943.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-c245-76f4-8bcd-56f95763a943",
        "storage_key": "property/6767906449166132/019d01ac-c245-76f4-8bcd-56f95763a943.webp",
        "width": 1280,
        "height": 895
      },
      "poi_business_url": "http://www.minneapolis.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18306040378800738842&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "minneapolis-college",
      "poi_latitude": "44.9728923",
      "poi_longitude": "-93.2832714",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 612-659-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f7d7-7708-ae05-5456914cea0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-f7d7-7708-ae05-5456914cea0e",
        "storage_key": "property/6767906449166132/019d01ac-f7d7-7708-ae05-5456914cea0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnWP8Zuoys1IRGhJgJrweDP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a58941dc-6a73-44ea-a7cf-575347aa0e2f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Augsburg University",
      "poi_type": "Education",
      "poi_address": "2211 Riverside Ave, Minneapolis, MN 55454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-c2e6-769f-8b03-098b73abd6d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-c2e6-769f-8b03-098b73abd6d6",
        "storage_key": "property/6767906449166132/019d01ac-c2e6-769f-8b03-098b73abd6d6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.augsburg.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2508554833933058645&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "augsburg-university",
      "poi_latitude": "44.9659238",
      "poi_longitude": "-93.24068400000002",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 612-330-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f7d7-7708-ae05-5456914cea0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-f7d7-7708-ae05-5456914cea0e",
        "storage_key": "property/6767906449166132/019d01ac-f7d7-7708-ae05-5456914cea0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJncjKGEcts1IRVUIroFQt0CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e00f2e9a-0dea-4429-81ce-893c9a174481",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Dunwoody College of Technology",
      "poi_type": "Education",
      "poi_address": "818 Dunwoody Blvd, Minneapolis, MN 55403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-c40f-71e4-bf07-2ffba5a42195.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-c40f-71e4-bf07-2ffba5a42195",
        "storage_key": "property/6767906449166132/019d01ac-c40f-71e4-bf07-2ffba5a42195.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dunwoody.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8043975208276418280&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "dunwoody-college-of-technology",
      "poi_latitude": "44.9727807",
      "poi_longitude": "-93.2901335",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 612-374-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f7d7-7708-ae05-5456914cea0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-f7d7-7708-ae05-5456914cea0e",
        "storage_key": "property/6767906449166132/019d01ac-f7d7-7708-ae05-5456914cea0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2XVn3ucys1IR6F5dR9XwoW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3bd3b335-058b-4ee7-9e5d-94ddd2c29bd8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "U.S. Bank Stadium",
      "poi_type": "Entertainment",
      "poi_address": "401 Chicago Ave, Minneapolis, MN 55415, USA",
      "poi_short_description": "Multi-use stadium for concerts, sports events and tours, plus home of the Vikings football team and the X Games.",
      "poi_long_description": "Fans say this stadium offers a thrilling game day experience with the energetic crowd chanting \"Skol\" and a loud stadium. They also highlight the friendly and helpful staff, and the reasonable prices for food and beverages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-c444-7398-9598-ec9c08b145b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-c444-7398-9598-ec9c08b145b5",
        "storage_key": "property/6767906449166132/019d01ac-c444-7398-9598-ec9c08b145b5.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.usbankstadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16516279991924342739&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "us-bank-stadium",
      "poi_latitude": "44.9736461",
      "poi_longitude": "-93.2574945",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 612-777-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-faed-76b8-8a4e-c865c65d9310.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-faed-76b8-8a4e-c865c65d9310",
        "storage_key": "property/6767906449166132/019d01ac-faed-76b8-8a4e-c865c65d9310.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ88m282Ats1IR07-KSSWdNeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_bf49b1df-58fc-44ba-8e1c-c452c24be70e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Target Field",
      "poi_type": "Entertainment",
      "poi_address": "1 Twins Way, Minneapolis, MN 55403, USA",
      "poi_short_description": "Baseball stadium offering seats for concerts and sports events, as well as some standing areas.",
      "poi_long_description": "People say this stadium offers a wide variety of food options, including hot dogs, nachos, and local specialties, and has a fun atmosphere with great views of the field and downtown. They highlight the convenient parking, easy access via public transportation, and the friendly and helpful staff. They also like the clean facilities and the spacious, open design that allows for easy movement.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-c77c-713c-9edf-4e610ae5b512.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-c77c-713c-9edf-4e610ae5b512",
        "storage_key": "property/6767906449166132/019d01ac-c77c-713c-9edf-4e610ae5b512.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mlb.com/twins/ballpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=16492843063147742549&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "target-field",
      "poi_latitude": "44.98174299999999",
      "poi_longitude": "-93.2776292",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 612-659-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-faed-76b8-8a4e-c865c65d9310.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-faed-76b8-8a4e-c865c65d9310",
        "storage_key": "property/6767906449166132/019d01ac-faed-76b8-8a4e-c865c65d9310.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJYc87o0ys1IRVcUvE2JZ4uQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_fab0bb51-01b3-4520-a201-e99d0c3e2f74",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Minneapolis Institute of Art",
      "poi_type": "Entertainment",
      "poi_address": "2400 3rd Ave S, Minneapolis, MN 55404, USA",
      "poi_short_description": "Free museum featuring a diverse collection of world art that spans from ancient to modern.",
      "poi_long_description": "People say this art museum offers a vast and diverse collection of paintings, sculptures, artifacts, and period rooms, spanning various artistic periods and cultures. They highlight the free admission, the beautiful architecture, and the thoughtfully curated exhibits. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-ca43-74ce-85f7-d23287bd412c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-ca43-74ce-85f7-d23287bd412c",
        "storage_key": "property/6767906449166132/019d01ac-ca43-74ce-85f7-d23287bd412c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://new.artsmia.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14207980514366553254&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "minneapolis-institute-of-art",
      "poi_latitude": "44.95850009999999",
      "poi_longitude": "-93.273218",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 888-642-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-faee-73b2-b0b6-d34a8479633d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-faee-73b2-b0b6-d34a8479633d",
        "storage_key": "property/6767906449166132/019d01ac-faee-73b2-b0b6-d34a8479633d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0k6WbEys1IRpnx9LgDjLMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_bb5fd8af-8483-4ec4-ad6f-9d6d313d95c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Edinborough Park",
      "poi_type": "Entertainment",
      "poi_address": "7700 York Ave S, Edina, MN 55435, USA",
      "poi_short_description": "Play area with a pool and workout area built to resemble an outdoor park, with ample seating for parents.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including a large indoor playground, slides, a gym with bikes and scooters, and a basketball court. They highlight the affordable prices, options for yearly passes, and the spacious, clean, and well-maintained environment. They also like the indoor setting, which provides a comfortable escape from the weather.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-ca62-70fa-bb31-6a9d0e9d39ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-ca62-70fa-bb31-6a9d0e9d39ad",
        "storage_key": "property/6767906449166132/019d01ac-ca62-70fa-bb31-6a9d0e9d39ad.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.edinboroughpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16696572479743564559&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "edinborough-park",
      "poi_latitude": "44.8629542",
      "poi_longitude": "-93.3220654",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 952-833-9540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUT6IPBQk9ocRD5utRTUktuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_10093d8a-2054-4afe-a40f-7d72b0be3db1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Mill City Museum",
      "poi_type": "Entertainment",
      "poi_address": "704 S 2nd St, Minneapolis, MN 55401, USA",
      "poi_short_description": "History of the flour industry told through interactive exhibits in the rebuilt ruins of an old mill.",
      "poi_long_description": "Visitors say this history museum offers an engaging look at the history of flour milling and its role in the development of Minneapolis, with interactive exhibits, a popular elevator ride to the Flour Tower, and a stunning observation deck with views of the city and river. They also highlight the friendly and knowledgeable staff, and the museum's educational value for both adults and children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-cb77-760c-8c26-e72c476646b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-cb77-760c-8c26-e72c476646b0",
        "storage_key": "property/6767906449166132/019d01ac-cb77-760c-8c26-e72c476646b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mnhs.org/millcity",
      "poi_directions_map_url": "https://maps.google.com/?cid=11052270807054118706&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "mill-city-museum",
      "poi_latitude": "44.9787748",
      "poi_longitude": "-93.25726",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 612-341-7555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-faee-73b2-b0b6-d34a8479633d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-faee-73b2-b0b6-d34a8479633d",
        "storage_key": "property/6767906449166132/019d01ac-faee-73b2-b0b6-d34a8479633d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9eTEmWMts1IRMm_h172NYZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_90afda7c-a5a4-42fb-ae67-53bef10c42c2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "5525 Cedar Lk Rd S, St Louis Park, MN 55416, USA",
      "poi_short_description": "Athletic country club with a fitness center, basketball and tennis courts, pools, and a variety of classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-cc61-715e-837a-f71c119588bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-cc61-715e-837a-f71c119588bb",
        "storage_key": "property/6767906449166132/019d01ac-cc61-715e-837a-f71c119588bb.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/mn/st-louis-park.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=6080654877908232223&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "44.9616245",
      "poi_longitude": "-93.3502154",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 952-541-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWRJk2qQ0s1IRH2h3D2XTYlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8db77ae3-cf3a-443a-8929-19bfeb3e9198",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Southdale YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "7355 York Ave S, Edina, MN 55435, USA",
      "poi_short_description": "Sprawling fitness center featuring a 6-lane lap pool as well as a climbing wall, a sauna and a steam room.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-d0e5-777f-ac0e-2dabb47ea272.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-d0e5-777f-ac0e-2dabb47ea272",
        "storage_key": "property/6767906449166132/019d01ac-d0e5-777f-ac0e-2dabb47ea272.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ymcanorth.org/locations/southdale_ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=1792742868037367309&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "southdale-ymca",
      "poi_latitude": "44.8698387",
      "poi_longitude": "-93.3198254",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 952-835-2567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa1OlZxgk9ocRDXb73iMa4Rg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_54804c1f-3858-4dae-89ec-6af68d138698",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3555 MN-100, St Louis Park, MN 55416, USA",
      "poi_short_description": "Chain featuring a gym with a pool and cardio stations, plus weight machines and free weights.",
      "poi_long_description": "People say this gym offers a wide variety of new machines and equipment, and the staff is helpful and friendly.\n\nOther reviews mention the gym can be busy during peak hours and some equipment can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-d4f6-71c7-8f31-038085035f91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-d4f6-71c7-8f31-038085035f91",
        "storage_key": "property/6767906449166132/019d01ac-d4f6-71c7-8f31-038085035f91.webp",
        "width": 1280,
        "height": 938
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=564&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8516207205732109283&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "44.9387261",
      "poi_longitude": "-93.3462906",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 763-392-1802",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuyF5-7Ag9ocR48tIM1WlL3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_958d7794-1c23-4ff6-a025-94c87bb71b12",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2852 26th Ave S, Minneapolis, MN 55406, USA",
      "poi_short_description": "Chain gym offering massage chairs and tanning services inside the Minnehaha Center.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and amenities, including massage chairs, tanning, and red light therapy. They also highlight the affordable membership options, spacious layout, and welcoming atmosphere.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-d51b-755c-884e-fc43a083a0df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-d51b-755c-884e-fc43a083a0df",
        "storage_key": "property/6767906449166132/019d01ac-d51b-755c-884e-fc43a083a0df.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/minneapolis-minnehaha-mn?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13605029185394094746&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "44.9511528",
      "poi_longitude": "-93.2379359",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 612-236-4176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6TSeI_Ep9ocRmrI8KvbFzrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_167cbc08-e582-45da-ab89-6c6c3ef684b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Blaisdell YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3335 Blaisdell Ave, Minneapolis, MN 55408, USA",
      "poi_short_description": "Gym with a swimming pool, an indoor track and a sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-d68d-70dc-a771-3a2f208928ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-d68d-70dc-a771-3a2f208928ac",
        "storage_key": "property/6767906449166132/019d01ac-d68d-70dc-a771-3a2f208928ac.webp",
        "width": 502,
        "height": 280
      },
      "poi_business_url": "http://www.ymcanorth.org/locations/blaisdell_ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=13804925343073064778&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "blaisdell-ymca",
      "poi_latitude": "44.9421175",
      "poi_longitude": "-93.2793183",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 612-827-5401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK05BwZIn9ocRSleoOHXylL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4fa7b601-02ea-430e-8baa-91a95c5c23f7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Ridgedale YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "12301 Ridgedale Dr, Minnetonka, MN 55305, USA",
      "poi_short_description": "Spacious, clean YMCA franchise offering indoor lap pools and group exercise classes, plus a fitness center, kid-care programs and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-d9b6-742f-9303-822ee36beea0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-d9b6-742f-9303-822ee36beea0",
        "storage_key": "property/6767906449166132/019d01ac-d9b6-742f-9303-822ee36beea0.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.ymcanorth.org/locations/ridgedale_ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=5253329195156302520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "ridgedale-ymca",
      "poi_latitude": "44.9654039",
      "poi_longitude": "-93.4350881",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 952-544-7708",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7y_1Bb1Ks1IRuOp61RGT50g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5cf3639e-37a4-49b9-99ec-9a1b7b45ec61",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Methodist Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6500 Excelsior Blvd, St Louis Park, MN 55426, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-d9eb-734e-8190-1738bb2ef996.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-d9eb-734e-8190-1738bb2ef996",
        "storage_key": "property/6767906449166132/019d01ac-d9eb-734e-8190-1738bb2ef996.webp",
        "width": 707,
        "height": 398
      },
      "poi_business_url": "https://www.healthpartners.com/care/hospitals/methodist/?utm_campaign=hospital_locallistings_20m1_care_methodist&utm_source=googlemybusiness_&utm_medium=organic&utm_content=methodist-hospital_localpack_conversion&utm_term=_v1__",
      "poi_directions_map_url": "https://maps.google.com/?cid=15982098137399073781&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "methodist-hospital",
      "poi_latitude": "44.9300754",
      "poi_longitude": "-93.3619384",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 952-993-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fb02-7055-bd9f-1bfd5bdc38d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fb02-7055-bd9f-1bfd5bdc38d2",
        "storage_key": "property/6767906449166132/019d01ac-fb02-7055-bd9f-1bfd5bdc38d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJMfcQqusg9ocR9ZsaRZTRy90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f5d5e7f2-ffe3-40e4-b83a-305f6d03a020",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "M Health Fairview Masonic Children's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2450 Riverside Ave, Minneapolis, MN 55454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-dc93-768e-80e5-9658b3b0655d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-dc93-768e-80e5-9658b3b0655d",
        "storage_key": "property/6767906449166132/019d01ac-dc93-768e-80e5-9658b3b0655d.webp",
        "width": 1280,
        "height": 807
      },
      "poi_business_url": "https://www.mhealthfairviewpeds.org/resources/Get-to-Know-M-Health-Fairview-Masonic-Childrens-Hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=17504372724993765568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "m-health-fairview-masonic-childrens-hospital",
      "poi_latitude": "44.966713",
      "poi_longitude": "-93.2372371",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 612-365-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fb02-7055-bd9f-1bfd5bdc38d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fb02-7055-bd9f-1bfd5bdc38d2",
        "storage_key": "property/6767906449166132/019d01ac-fb02-7055-bd9f-1bfd5bdc38d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnxM5Kj0ts1IRwDBKUUAG7PI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_bc908694-2160-4a68-b7d8-70a1172f67ff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Minneapolis Sculpture Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "725 Vineland Pl, Minneapolis, MN 55403, USA",
      "poi_short_description": "Green, peaceful, dog-friendly park featuring whimsical sculptures, floral displays, an arbo and a meadow.",
      "poi_long_description": "Visitors say this sculpture garden offers a relaxing stroll with impressive modern art, including the iconic Spoonbridge and Cherry sculpture, set amongst lush green lawns and native wildflowers. They also highlight the free admission, well-maintained grounds, and proximity to other cultural attractions like the Walker Art Center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-de09-734d-a461-660674bc0f3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-de09-734d-a461-660674bc0f3c",
        "storage_key": "property/6767906449166132/019d01ac-de09-734d-a461-660674bc0f3c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.walkerart.org/garden/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6037934690900938095&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "minneapolis-sculpture-garden",
      "poi_latitude": "44.96954789999999",
      "poi_longitude": "-93.2897803",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 612-375-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fe08-704f-a58f-33bc7b54cab6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fe08-704f-a58f-33bc7b54cab6",
        "storage_key": "property/6767906449166132/019d01ac-fe08-704f-a58f-33bc7b54cab6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCVqalcIys1IRb40obJwNy1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_08fe3b21-de55-42b9-abae-9ee4119f6197",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Centennial Lakes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7499 France Ave S, Edina, MN 55435, USA",
      "poi_short_description": "Scenic park featuring walking trails, pedal boats, mini golf and an amphitheater for concerts, alongside a lake and benches.",
      "poi_long_description": "People say this park offers ice skating in the winter. They highlight the safe and fun vibe, and the affordable skate rentals. They also like the concession stand with snacks and drinks. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-df4b-753a-bf61-f42915b1dc61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-df4b-753a-bf61-f42915b1dc61",
        "storage_key": "property/6767906449166132/019d01ac-df4b-753a-bf61-f42915b1dc61.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.centenniallakespark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16363237183097779346&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "centennial-lakes-park",
      "poi_latitude": "44.8669226",
      "poi_longitude": "-93.3260174",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 952-833-9580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fe08-704f-a58f-33bc7b54cab6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fe08-704f-a58f-33bc7b54cab6",
        "storage_key": "property/6767906449166132/019d01ac-fe08-704f-a58f-33bc7b54cab6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8c1CZBAk9ocRkrQBmoXlFeM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e615cb87-0d5f-484e-9532-ce0f969a644b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Lake Harriet Bandshell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4135 W Lake Harriet Pkwy, Minneapolis, MN 55409, USA",
      "poi_short_description": "Popular park featuring a bandshell, beach, swimming area, and snack bar.",
      "poi_long_description": "People say this park offers kayaking, paddle boating, and live music performances. They highlight the beautiful lake views, the well-maintained trails, and the free concerts and yoga classes. They also like the relaxed and enjoyable atmosphere, and the availability of food and drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-df67-7736-b6b5-1bded01bc977.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-df67-7736-b6b5-1bded01bc977",
        "storage_key": "property/6767906449166132/019d01ac-df67-7736-b6b5-1bded01bc977.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://minneapolisparks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8458957997012670662&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "lake-harriet-bandshell-park",
      "poi_latitude": "44.9281483",
      "poi_longitude": "-93.3076867",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 612-230-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fe08-704f-a58f-33bc7b54cab6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fe08-704f-a58f-33bc7b54cab6",
        "storage_key": "property/6767906449166132/019d01ac-fe08-704f-a58f-33bc7b54cab6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQ-JEQ4n9ocRxtjjFXtBZHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9906c8ca-fadc-4ef4-8c4a-c525615850f5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Boom Island Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "724 Sibley St NE, Minneapolis, MN 55413, USA",
      "poi_short_description": "Popular park featuring a playground, as well as shelters, lawns, and barbecues.",
      "poi_long_description": "People say this park offers trails, picnic areas, and riverfront access with beautiful views of the city skyline and Mississippi River. They highlight the spacious, clean, and serene atmosphere, and the availability of amenities such as restrooms, parking, and covered areas for events. They also like the opportunities for walking, biking, and enjoying outdoor activities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-e31a-7440-9ccc-b7f6e76e3607.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-e31a-7440-9ccc-b7f6e76e3607",
        "storage_key": "property/6767906449166132/019d01ac-e31a-7440-9ccc-b7f6e76e3607.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.minneapolisparks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7313812877127864044&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "boom-island-park",
      "poi_latitude": "44.9920367",
      "poi_longitude": "-93.2686552",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 612-230-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fe08-704f-a58f-33bc7b54cab6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fe08-704f-a58f-33bc7b54cab6",
        "storage_key": "property/6767906449166132/019d01ac-fe08-704f-a58f-33bc7b54cab6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZYd6KSgts1IR7E7ivg_if2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_dc45004e-13b5-4c22-8d0f-43680e6f87ff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Theodore Wirth Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1301 Theodore Wirth Pkwy, Golden Valley, MN 55422, USA",
      "poi_short_description": "Wildflower-filled park featuring a chalet, hiking trails, and recreational lakes.",
      "poi_long_description": "People say this park offers well-maintained hiking and mountain biking trails, a golf course, and a cafe with delicious food and chai tea. They highlight the park's vast size, beautiful views, and free parking, as well as the smooth trails suitable for various skill levels. They also like the occasional live music and the availability of a bike maintenance station. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-e3a3-74e9-a7b5-a94ded77efb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-e3a3-74e9-a7b5-a94ded77efb0",
        "storage_key": "property/6767906449166132/019d01ac-e3a3-74e9-a7b5-a94ded77efb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.minneapolisparks.org/parks__destinations/parks__lakes/theodore_wirth_regional_park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17121310475486625482&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "theodore-wirth-regional-park",
      "poi_latitude": "44.9898452",
      "poi_longitude": "-93.3268367",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 612-230-6528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fe08-704f-a58f-33bc7b54cab6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fe08-704f-a58f-33bc7b54cab6",
        "storage_key": "property/6767906449166132/019d01ac-fe08-704f-a58f-33bc7b54cab6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTW_6IRMzs1IRyv6NNCodm-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_319963bd-8538-4e11-929e-fbd053b39730",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "East Bank",
      "poi_type": "Transportation & Transit",
      "poi_address": "Minneapolis, MN 55455, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-e68f-7498-b63b-f44160b79ee4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-e68f-7498-b63b-f44160b79ee4",
        "storage_key": "property/6767906449166132/019d01ac-e68f-7498-b63b-f44160b79ee4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11372311984788066584&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "east-bank",
      "poi_latitude": "44.9736955",
      "poi_longitude": "-93.231058",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB4vy7xcts1IRGNE1QH-R0p0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_05df0610-8045-4f17-bb8e-21759eb06202",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Warehouse District/Hennepin Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Minneapolis, MN 55401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-e677-7241-966e-c084abe3d156.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-e677-7241-966e-c084abe3d156",
        "storage_key": "property/6767906449166132/019d01ac-e677-7241-966e-c084abe3d156.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10497940574180118857&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "warehouse-districthennepin-ave",
      "poi_latitude": "44.9800346",
      "poi_longitude": "-93.2730954",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlw7mOJAys1IRSZEq7VQtsJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_4836a461-0287-4887-a41e-3759493a10c5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Target Field Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Minneapolis, MN 55401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-ea1f-735e-957d-79196b90e558.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-ea1f-735e-957d-79196b90e558",
        "storage_key": "property/6767906449166132/019d01ac-ea1f-735e-957d-79196b90e558.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.metrotransit.org/NexTripBadge.aspx?stopnumber=53342",
      "poi_directions_map_url": "https://maps.google.com/?cid=8286325833882169780&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "target-field-station",
      "poi_latitude": "44.9832626",
      "poi_longitude": "-93.2770758",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fe06-7536-98f3-834fde3db065.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fe06-7536-98f3-834fde3db065",
        "storage_key": "property/6767906449166132/019d01ac-fe06-7536-98f3-834fde3db065.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0YA1Y0ys1IRtHGwbXHx_nI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_db1e95c1-d33e-4bee-9e50-ad6be041393d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Nicollet Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "Minneapolis, MN 55401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-ea40-7668-8306-0832ca723dfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-ea40-7668-8306-0832ca723dfc",
        "storage_key": "property/6767906449166132/019d01ac-ea40-7668-8306-0832ca723dfc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16088033710719254394&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "nicollet-mall",
      "poi_latitude": "44.9785783",
      "poi_longitude": "-93.2699344",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL2AFXZoys1IRej_u_WstRN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_198a2867-03b3-429d-ba7d-1d49ab3050e1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Government Plaza",
      "poi_type": "Transportation & Transit",
      "poi_address": "Minneapolis, MN 55487, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-ee2c-7655-bede-d729a0fbb088.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-ee2c-7655-bede-d729a0fbb088",
        "storage_key": "property/6767906449166132/019d01ac-ee2c-7655-bede-d729a0fbb088.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1944303954529763037&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "government-plaza",
      "poi_latitude": "44.9768693",
      "poi_longitude": "-93.26616",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtWlIAJwys1IR3T4iMSWO-xo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_2789ed71-93cc-4170-8f1a-a26f562a5580",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "General Mills World Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 General Mills Blvd, Golden Valley, MN 55426, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-ece7-711d-96a4-1acf3cc6a817.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-ece7-711d-96a4-1acf3cc6a817",
        "storage_key": "property/6767906449166132/019d01ac-ece7-711d-96a4-1acf3cc6a817.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.generalmills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3187201480361361212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "general-mills-world-headquarters",
      "poi_latitude": "44.9759852",
      "poi_longitude": "-93.3978452",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-248-7310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM4Gn6BE1s1IRPL-JINw2Oyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f52eeb25-a8f5-45bd-8eef-b57d6702a38d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Optum",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Optum Cir, Eden Prairie, MN 55344, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-efd9-73e5-857a-1d2f1db77755.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-efd9-73e5-857a-1d2f1db77755",
        "storage_key": "property/6767906449166132/019d01ac-efd9-73e5-857a-1d2f1db77755.webp",
        "width": 1280,
        "height": 936
      },
      "poi_business_url": "http://www.optum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3421533486180131994&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "optum",
      "poi_latitude": "44.8901572",
      "poi_longitude": "-93.4153791",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 888-445-8745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ36kzLuEh9ocRmuTe3pO6ey8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cb24730c-ec36-4879-8b1a-3c0e64e47779",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "IDS Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "80 S 8th St, Minneapolis, MN 55402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f073-7130-a8db-0f53168973e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-f073-7130-a8db-0f53168973e1",
        "storage_key": "property/6767906449166132/019d01ac-f073-7130-a8db-0f53168973e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ids-center.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11753551650961338901&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "ids-center",
      "poi_latitude": "44.9761367",
      "poi_longitude": "-93.2725394",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 612-376-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkbv8OJcys1IRFbLBHPQAHaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0d031a38-49b7-4f2c-bf79-415c6c231ee1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Ameriprise Financial Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "901 3rd Ave S, Minneapolis, MN 55402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f288-7733-8935-71d25d4b658c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-f288-7733-8935-71d25d4b658c",
        "storage_key": "property/6767906449166132/019d01ac-f288-7733-8935-71d25d4b658c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ameriprise.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8796296674471361197&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "ameriprise-financial-headquarters",
      "poi_latitude": "44.972654",
      "poi_longitude": "-93.2698608",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 612-671-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL8x8EJgys1IRrbrQfDi5Eno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a27c9d41-16a2-44ff-b397-f8292cc9897b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "poi_name": "Ameriprise Financial Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "901 3rd Ave S, Minneapolis, MN 55402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-f329-724f-abad-92eca8d8ee03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ac-f329-724f-abad-92eca8d8ee03",
        "storage_key": "property/6767906449166132/019d01ac-f329-724f-abad-92eca8d8ee03.webp",
        "width": 1280,
        "height": 885
      },
      "poi_business_url": "https://www.ameriprise.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7494088706523804793&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "ameriprise-financial-center",
      "poi_latitude": "44.972609",
      "poi_longitude": "-93.2697421",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 612-671-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ac-fafa-710e-aef9-9a3d39a60bca",
        "storage_key": "property/6767906449166132/019d01ac-fafa-710e-aef9-9a3d39a60bca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42nwvpkys1IReTSeI_lZAGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9e689e6304202e108b77762f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_39d2315c8327bd157440f06f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_6483da76b37f365eb6f865e4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_e1862dfef02bb59af67ea49f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_c8a9d26540388727a50dcecc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_d6a827de4b1d4a45abf8b9e9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_2a7df3780f764ff0697e45e6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "rating": "5",
      "name": "Graig Churchill",
      "text": "Amazing apartment complex! Amenities are top notch. Proximity to the lake and shops make it a perfect place to live!",
      "date": "2025-05-14",
      "title": "false"
    },
    {
      "id": "ec_e3bbcd75793892e960bfc7bc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "rating": "5",
      "name": "Dino",
      "text": "The staff at Lakehaus goes above and beyond every single day to ensure the residents are fully taken care of and all of their requests and needs are met. Sara, the leasing manager is amazing. Somehow, she is always in a great mood and welcomes you with a smile that makes anyone feel like she's your best friend. Dmitriy and Jeff are part of the maintenance team. Any service request I've ever had has been taken care of within 24 hours or less. Even through a passive conversation your request is heard. For example, the water filter in the locker room was needing replacement which I spoke to Dmitriy about. 10 minutes later Jeff was in the locker room replacing the filter. Lakehaus ensures the residents are worry free and they can focus on other things like enjoying the views from the top floor.",
      "date": "2024-09-27",
      "title": "false"
    },
    {
      "id": "ec_8177e80234bda929c6b80c32",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "rating": "5",
      "name": "Steve Richter",
      "text": "We had the pleasure of living at Lakehaus for 18 months. Following a house fire we were searching for temporary housing. Because we have a dog and haven’t lived in an apartment for many years, apartment living was not our first choice. We feel very lucky to have taken the chance on Lakehaus. I highly recommend this building. The amenities are luxury resort quality, the building is always immaculate, and the staff is amazing. It turns out that the  building is very dog friendly and the location is perfect, with access to the Greenway, the chain of lakes, and shops and restaurants. But, by far the best part of the experience for us was being part of the community. This group, ranging  from 20 something to 70 and beyond, interacts seamlessly. The staff does a great job of organizing events and they are typically well attended. We made real friends and will always remember our time at Lakehaus. That community made a potentially rough time in our lives, memorable. If you are on the fence, take the chance. The guest parking is a struggle, but definitely not a deal breaker.",
      "date": "2024-01-19",
      "title": "false"
    },
    {
      "id": "ec_726e9ead7b7975fee7de1bce",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "rating": "5",
      "name": "Mary Beth Gallagher",
      "text": "I moved here 6 months ago and so happy I did! The place is gorgeous and meticulously maintained. Security is top-notch! Management and staff are always available and execute amazing resident events. There is a genuine community vibe here like none other. Lack of guest parking is the only challenge, however residents help each other out.",
      "date": "2024-01-23",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_d2145de2-113f-4246-bb35-70672234f23e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019f3e6f-9cde-77d5-9bcc-2e435f3629c7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f3e6f-9cde-77d5-9bcc-2e435f3629c7",
        "storage_key": "property/6767906449166132/019f3e6f-9cde-77d5-9bcc-2e435f3629c7.webp",
        "width": 150,
        "height": 75
      },
      "virtual_tour_title": "Lakehaus",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://viewer.panoskin.com/?id=virtualTour&tour=5fecbc2a168e057d7c000897&themeId=5db5f9bdd2988f1d481bb6b2&sourceId=2000"
    },
    {
      "id": "custom_c856deb7-394b-498e-8585-bd52c4584d33",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01b1-09b3-7159-a640-dbbf242b114d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Entryway with a console table, coat rack, and artwork.",
        "public_id": "019d01b1-09b3-7159-a640-dbbf242b114d",
        "storage_key": "property/6767906449166132/019d01b1-09b3-7159-a640-dbbf242b114d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Lakehaus - 2BD-2BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ffqRe1xhZat&play=1"
    },
    {
      "id": "custom_78bfdfab-1de3-4b95-a2ae-1f55caa8083e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01b1-09f0-751f-9abd-3b908a18441c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious, modern lounge area with comfortable seating, coffee tables, and ambient lighting.",
        "public_id": "019d01b1-09f0-751f-9abd-3b908a18441c",
        "storage_key": "property/6767906449166132/019d01b1-09f0-751f-9abd-3b908a18441c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Lakehaus Lobby",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FFExinzxHup&play=1"
    },
    {
      "id": "custom_c1d5d54d-1420-4792-ba3f-53a77858d4f1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166132/019d01b1-1266-761d-8ade-2ca4c696c45b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern apartment kitchen with stainless steel appliances and island.",
        "public_id": "019d01b1-1266-761d-8ade-2ca4c696c45b",
        "storage_key": "property/6767906449166132/019d01b1-1266-761d-8ade-2ca4c696c45b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Lakehaus - Alcove - 595SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=fn4Ha6TXL8Y&play=1"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_4cd046072206ad3c6d21f98c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "a1a97f57ece10c49",
      "name": "NSF Tenant Fee",
      "description": "NSF Tenant Fee",
      "amount": 30,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "nsff",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_91b6f2731dafdec90cda409a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "dc8adfadb0a1aaf6",
      "name": "Late Fee",
      "description": "Late Fee",
      "amount": 8,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "late",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_473911e557893adbfb6aecac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "cea07e4fca0e1bff",
      "name": "Lease Termination Fee",
      "description": "Lease Termination Fee",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Term",
      "charge_code": "term",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_66462906d25bb739dd70dfd2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "3faabaa67cff1d97",
      "name": "Transfer Fee",
      "description": "Transfer Fee",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Transfer",
      "charge_code": "tran",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c50f2a7f27a31a98d9f61c07",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "da0f3184cbbf9893",
      "name": "Water Charge",
      "description": "Water Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage based, paid monthly",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubwater",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_84568f69184c1823efcbf97b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "135bd527c15aa0ce",
      "name": "Sewer Charge",
      "description": "Sewer Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage based, paid monthly",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubsewer",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_522761585c3dbc1660cd453f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "ec8a7d9e0f8ff30d",
      "name": "Electric Charge",
      "description": "Electric Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage based, paid monthly",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "elec",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9732c24679b9acda51e2b562",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "a414ecc4b762ea6e",
      "name": "Gas Charge",
      "description": "Gas Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage based, paid monthly",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "gasc",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_871d69533ee1bb79f9867ec4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "8ec1c4fb2a86979c",
      "name": "Utility Billing Admin Fee",
      "description": "Utility Billing Admin Fee",
      "amount": 8,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubadmin",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f37e0d8aa1fbf6acf4aa694a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "18d6b18141264533",
      "name": "Trash Charge",
      "description": "Trash Utility Charge – Based on Square Footage and Occupancy",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally distributed",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubtrash",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_7fbcc96041d4e2dd31c19567",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "29d0baf9b2589256",
      "name": "Pet Screening Fee",
      "description": "Pet Screening Fee - $30 for Card Payments, $25 for ACH Payments. No cost for verified Service Animals.",
      "amount": 25,
      "amount_max": 30,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Move-In",
      "category": "Pet",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [
    {
      "id": "ec_7392eb603a3cc79873a75750",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "2649546",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 300,
      "fee": 300,
      "monthly_rent": 40,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_f0c91cf2433a720b8241b888",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "yardi",
      "external_id": "2649545",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 300,
      "fee": 300,
      "monthly_rent": 40,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "019910d3-b0b0-742a-b524-d56af1db558f",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Lake Haus property website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132"
    },
    {
      "lead_collector_id": "019910d3-b12f-74a7-9453-fb0cd902ec37",
      "lead_source": "FACEBOOK_ADS",
      "name": "Lake Haus facebook ads",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132"
    },
    {
      "lead_collector_id": "019910d3-b1a9-7031-9029-0615e08611a7",
      "lead_source": "LANDING_PAGE",
      "name": "Lake Haus landing page",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "lake-view-apartments-minneapolis-mn",
      "search_query": "lake view apartments Minneapolis MN",
      "category": "Amenity",
      "h1_title": "Lake View Apartments in Minneapolis, MN",
      "h2_subtitle": "Discover stunning lake view apartments in Minneapolis, MN. Enjoy luxury living with breathtaking vistas and premium amenities at Lake Haus.",
      "page_copy": "Experience the pinnacle of luxury living with lake view apartments in Minneapolis, MN, right at Lake Haus. Located in the vibrant Triangle neighborhood, our one and two-bedroom floor plans offer residents not just a home, but an experience of modern elegance with expansive views of Lake Bde Maka Ska. Whether you're sipping coffee on your private balcony or lounging by our rooftop pool, each corner is designed to offer breathtaking vistas.\n\nLake Haus features top-tier amenities like a state-of-the-art fitness center and a Peloton cycling and yoga studio, perfect for maintaining an active lifestyle. Our pet-loving residents will appreciate the outdoor dog park, providing a refreshing space for their furry companions. Join us at Lake Haus and redefine luxury living in a community that celebrates the best of Minneapolis with unbeatable lake views and modern comforts.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lake View Apartments in Minneapolis, MN | Lake Haus",
      "seo_description": "Luxury lake view apartments in Minneapolis, MN at Lake Haus. Enjoy spectacular views of Lake Bde Maka Ska and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-hennepin-county",
      "search_query": "luxury apartments with pool in Hennepin County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Hennepin County",
      "h2_subtitle": "Discover luxury living with a pool in Hennepin County. Lake Haus offers premium amenities and stunning lake views.",
      "page_copy": "Elevate your living experience at Lake Haus, offering luxury apartments with a pool in Hennepin County. Nestled in the Triangle neighborhood of Minneapolis, Lake Haus provides more than just a place to live—it's a gateway to a chic, urban lifestyle. Indulge in expansive views of Lake Bde Maka Ska from our rooftop pool, the perfect spot to unwind and soak up the sun.\n\nOur community is designed with modern elegance and convenience in mind. Residents enjoy a state-of-the-art fitness center, a Peloton cycling and yoga studio, and a bike repair shop. The white-wash oak hardwood plank flooring and Moen fixtures inside our one or two-bedroom apartments add to the luxurious ambiance. Discover unmatched comfort and style in Hennepin County at Lake Haus, where luxury living is an everyday affair.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool | Hennepin County",
      "seo_description": "Find luxury apartments with a pool in Hennepin County at Lake Haus. Enjoy modern finishes and top amenities including a rooftop pool and fitness center.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-near-lake-bde-maka-ska",
      "search_query": "pet-friendly apartments near Lake Bde Maka Ska",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments Near Lake Bde Maka Ska",
      "h2_subtitle": "Find pet-friendly apartments near Lake Bde Maka Ska at Lake Haus. Enjoy spacious living and amenities designed for you and your furry friend.",
      "page_copy": "Welcome to Lake Haus, where our pet-friendly apartments near Lake Bde Maka Ska offer a blend of luxury and comfort. Situated in the bustling Triangle neighborhood of Minneapolis, our community is ideal for pet owners who desire a sophisticated yet practical living environment. With expansive views of the nearby lake, you and your four-legged companion will love living where nature and urban convenience meet.\n\nAt Lake Haus, we understand that pets are family, which is why we offer an outdoor dog park to keep your furry friends active and happy. Besides this, our residents enjoy premium facilities, including a state-of-the-art fitness center and a chic rooftop pool with stunning lake vistas. Choose from our one or two-bedroom floor plans, each designed with modern finishes and plenty of space for you and your pet to thrive. Join a community that offers a blend of luxury and pet-friendly amenities right by Lake Bde Maka Ska.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Near Lake Bde Maka Ska",
      "seo_description": "Pet-friendly living at Lake Haus. Enjoy luxurious apartments near Lake Bde Maka Ska with dog park and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-triangle-minneapolis",
      "search_query": "apartments with in-unit laundry in Triangle Minneapolis",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Triangle",
      "h2_subtitle": "Discover apartments with in-unit laundry in Triangle, Minneapolis. Lake Haus offers modern convenience and luxury living.",
      "page_copy": "Lake Haus presents the ultimate choice for those seeking apartments with in-unit laundry in the Triangle area of Minneapolis. Perfectly positioned to offer both urban flair and serene lakeside living, our community meets the demands of contemporary lifestyles. Each one and two-bedroom apartment boasts modern finishes, including the convenience of in-unit laundry, ensuring you have more time to enjoy the luxuries of life.\n\nLive where lifestyle meets comfort, with amenities such as a rooftop pool, a state-of-the-art fitness center, and a Peloton cycling and yoga studio. The nearby Lake Bde Maka Ska offers additional recreational opportunities, while our pet-friendly outdoor dog park ensures your furry friends feel at home too. Find your new residence at Lake Haus, where in-unit laundry is just the beginning of exceptional apartment living in Triangle, Minneapolis.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Triangle, Minneapolis",
      "seo_description": "Find apartments with in-unit laundry in Triangle, Minneapolis at Lake Haus. Enjoy modern living with premium amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "dog-park-apartments-55416",
      "search_query": "dog park apartments in 55416",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in 55416",
      "h2_subtitle": "Explore dog park apartments in 55416 at Lake Haus. Experience unmatched amenities and pet-friendly living in Minneapolis.",
      "page_copy": "Welcome to Lake Haus, situated in the vibrant 55416 area, where our dog park apartments offer a perfect blend of luxury and pet-friendly amenities. Located near the serene Lake Bde Maka Ska, Lake Haus provides an exceptional living experience for both residents and their furry companions. Our community features an outdoor dog park, ensuring that pets, big and small, have a dedicated space to enjoy and socialize.\n\nIn addition to the dog park, residents can take advantage of luxurious amenities, including a stunning rooftop pool and a state-of-the-art fitness center. Choose from our chic one or two-bedroom floor plans, each designed with modern fixtures and finishes, such as white-wash oak hardwood plank flooring. Living in the Triangle neighborhood of Hennepin County, you'll enjoy the best of urban and lakeside living. Come home to Lake Haus, where both you and your pet will thrive.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in 55416",
      "seo_description": "Find dog park apartments in the 55416 area at Lake Haus. Enjoy pet-friendly living with a dedicated dog park and luxury amenities in Minneapolis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-minneapolis-mn",
      "search_query": "one bedroom apartments minneapolis mn",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Minneapolis, MN",
      "h2_subtitle": "Discover chic one-bedroom apartments in Minneapolis, MN at Lake Haus. Experience luxury and convenience in the Triangle neighborhood.",
      "page_copy": "Lake Haus offers sophisticated one-bedroom apartments in Minneapolis, MN, perfectly situated in the vibrant Triangle neighborhood. Our thoughtfully designed residences blend modern style with comfort, featuring elegant finishes that complement any lifestyle. Each one-bedroom apartment provides expansive views of Lake Bde Maka Ska, creating a serene atmosphere in this urban setting.\n\nExperience the best in luxury living with an array of amenities right at your doorstep. From state-of-the-art fitness facilities, including a Peloton cycling and yoga studio, to a refreshing rooftop pool, Lake Haus offers everything you need for a balanced life. Whether you’re enjoying a leisurely walk around the lake or utilizing the on-site bike repair shop, Lake Haus is the perfect place to call home in Minneapolis. Discover unparalleled living in our one-bedroom apartments today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Minneapolis, MN",
      "seo_description": "Explore one-bedroom apartments in Minneapolis, MN at Lake Haus. Enjoy modern design and luxury amenities in the Triangle neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-hennepin-county",
      "search_query": "two bedroom apartments in hennepin county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Hennepin County",
      "h2_subtitle": "Explore two-bedroom apartments in Hennepin County at Lake Haus. Luxury living in a premier Minneapolis location awaits you.",
      "page_copy": "Discover the elegance of two-bedroom apartments in Hennepin County at Lake Haus, where sophisticated living meets an ideal location. Situated in Minneapolis's sought-after Triangle area, Lake Haus provides a perfect blend of urban life and scenic views, right next to the alluring Lake Bde Maka Ska. Our spacious two-bedroom layouts are designed with modern touches, including Moen fixtures and white-wash oak hardwood plank flooring, ensuring a visually appealing and functional living space.\n\nLake Haus offers a wealth of amenities tailored for your lifestyle needs. Enjoy a relaxing swim in the rooftop pool or maintain your fitness routine in our state-of-the-art gym, complete with a Peloton cycling and yoga studio. Our expansive outdoor dog park invites you and your pets to enjoy the outdoors together. Make the move to Lake Haus and experience the premium life of Hennepin County in our two-bedroom apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Hennepin County",
      "seo_description": "Find two-bedroom apartments in Hennepin County at Lake Haus. Enjoy luxury living near Lake Bde Maka Ska with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-minnesota-minneapolis",
      "search_query": "apartments near University of Minnesota Minneapolis",
      "category": "School",
      "h1_title": "Apartments Near University of Minnesota Minneapolis",
      "h2_subtitle": "Discover luxury apartments near the University of Minnesota in Minneapolis at Lake Haus. Experience unmatched comfort and convenience.",
      "page_copy": "Lake Haus offers premier living accommodations just a short distance from the University of Minnesota in Minneapolis. Positioned in the vibrant Triangle neighborhood, our apartments provide easy access for university students and faculty, blending convenience with luxury. Whether you choose a one or two-bedroom floor plan, you’ll find expansive views of Lake Bde Maka Ska and interiors featuring chic finishes like Moen fixtures and white-wash oak hardwood plank flooring.\n\nLiving at Lake Haus means enjoying exceptional amenities, designed to enhance your university lifestyle. From a state-of-the-art fitness center and Peloton cycling studio to a rooftop pool perfect for relaxation or study breaks, everything you need is right at home. The community also boasts a refreshing outdoor dog park, perfect for pet owners. Experience the perfect blend of student life and upscale living at Lake Haus, where convenience meets comfort near the University of Minnesota.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near University of Minnesota Minneapolis",
      "seo_description": "Explore luxurious apartments near the University of Minnesota in Minneapolis at Lake Haus. Enjoy proximity and comfort with top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "apartments-close-to-minneapolis-college-triangle",
      "search_query": "apartments close to Minneapolis College Triangle",
      "category": "School",
      "h1_title": "Apartments Close to Minneapolis College",
      "h2_subtitle": "Explore luxurious living at Lake Haus, located near Minneapolis College in the Triangle neighborhood. Enjoy convenience and style.",
      "page_copy": "Lake Haus offers upscale apartment living conveniently located near Minneapolis College in the vibrant Triangle neighborhood. Ideal for students and professionals alike, these chic apartments provide a welcoming retreat from busy schedules, with modern interiors and stunning views of Lake Bde Maka Ska. Choose from our sophisticated one or two-bedroom layouts, all offering refined finishes like Moen fixtures and white-wash oak hardwood plank flooring.\n\nExperience luxury with an array of amenities that cater to your lifestyle needs. Maintain your wellness routine at our state-of-the-art fitness center or unwind at the rooftop pool between classes or work sessions. The Peloton cycling and yoga studio offers an invigorating alternative to your usual workouts, while our outdoor dog park provides a perfect spot for relaxation. Choose Lake Haus for its proximity and embrace a home that balances luxury and convenience near Minneapolis College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Minneapolis College in Triangle",
      "seo_description": "Find stylish apartments close to Minneapolis College in the Triangle area at Lake Haus. Enjoy urban living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "luxury-rentals-by-augsburg-university-mn",
      "search_query": "luxury rentals by Augsburg University MN",
      "category": "School",
      "h1_title": "Luxury Rentals by Augsburg University MN",
      "h2_subtitle": "Discover premier luxury rentals near Augsburg University in MN at Lake Haus. Experience upscale living in a prime location.",
      "page_copy": "For luxury rentals near Augsburg University in MN, Lake Haus stands out as an exceptional choice. Nestled in the dynamic Triangle neighborhood of Minneapolis, Lake Haus merges convenient city living with the tranquility of lakeside views, offering an ideal retreat for students and faculty alike. Our finely-appointed one and two-bedroom apartments feature sophisticated designs, complete with Moen fixtures and white-wash oak hardwood plank flooring.\n\nAt Lake Haus, the blend of comfort and style extends beyond the apartments to our diverse range of amenities. Enjoy working out at our state-of-the-art fitness center, indulge in relaxation at the rooftop pool, or find peace in the Peloton cycling and yoga studio. For pet lovers, our outdoor dog park is the perfect spot for both exercise and play. Join our community at Lake Haus, where luxurious living meets a convenient location near Augsburg University.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Rentals by Augsburg University MN",
      "seo_description": "Explore luxury rentals near Augsburg University MN at Lake Haus. Enjoy premium living with top amenities and stunning views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "living-near-bruininks-hall-hennepin-county",
      "search_query": "living near Bruininks Hall Hennepin County",
      "category": "School",
      "h1_title": "Living Near Bruininks Hall, Hennepin County",
      "h2_subtitle": "Experience premier living near Bruininks Hall in Hennepin County at Lake Haus. Discover convenience and luxury combined.",
      "page_copy": "Lake Haus offers an exceptional lifestyle for those looking to live near Bruininks Hall in Hennepin County. Situated in the Triangle neighborhood, our community combines the best of city living with the tranquility of Lake Bde Maka Ska views, ideal for students and professionals alike. Choose from our stylish one or two-bedroom apartments, featuring modern touches like Moen fixtures and white-wash oak hardwood flooring.\n\nEnhance your lifestyle with our array of upscale amenities. Whether you're hitting the state-of-the-art fitness center, cycling in the Peloton studio, or unwinding at the rooftop pool, you'll find everything you need right at home. Pet owners will appreciate our spacious outdoor dog park. Lake Haus is more than just a place to live; it's a vibrant community nestled in Hennepin County that's just a short journey away from Bruininks Hall.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Bruininks Hall, Hennepin County",
      "seo_description": "Discover Lake Haus for upscale living near Bruininks Hall in Hennepin County. Enjoy luxury amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "apartments-near-methodist-hospital-minneapolis",
      "search_query": "apartments near Methodist Hospital Minneapolis",
      "category": "Hospital",
      "h1_title": "Apartments near Methodist Hospital Minneapolis",
      "h2_subtitle": "Find convenient and luxurious apartments near Methodist Hospital in Minneapolis at Lake Haus. Experience comfort and style.",
      "page_copy": "Lake Haus is an ideal choice for those seeking apartments near Methodist Hospital in Minneapolis. Located in the vibrant Triangle neighborhood, our community provides the perfect blend of luxury and accessibility. Our spacious one and two-bedroom floor plans feature modern designs with premium finishes like Moen fixtures and white-wash oak hardwood plank flooring, ensuring a stylish home environment.\n\nBenefit from the extensive amenities that Lake Haus offers. Whether you're staying active in our state-of-the-art fitness center or enjoying a leisurely swim in the rooftop pool, you’ll find everything you need just steps away. The Peloton cycling and yoga studio offers a refreshing workout alternative, while our outdoor dog park is perfect for both exercise and relaxation. Choose Lake Haus for its proximity and embrace a comfortable lifestyle near Methodist Hospital in Minneapolis.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts near Methodist Hospital Minneapolis",
      "seo_description": "Explore Lake Haus for luxurious apartments near Methodist Hospital in Minneapolis. Enjoy premium amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "apartments-close-to-m-health-fairview-hospital",
      "search_query": "apartments close to M Health Fairview Masonic Children's Hospital in Hennepin County",
      "category": "Hospital",
      "h1_title": "Apts Close to M Health Fairview Masonic Hospital",
      "h2_subtitle": "Discover the ideal apartments close to M Health Fairview Masonic Children's Hospital in Hennepin County. Experience comfort at Lake Haus.",
      "page_copy": "Lake Haus offers an exceptional living experience for those looking for apartments close to M Health Fairview Masonic Children's Hospital in Hennepin County. Nestled in the vibrant Triangle neighborhood, our luxurious one and two-bedroom options are designed with modern features, including Moen fixtures and white-wash oak hardwood plank flooring, ensuring a perfect blend of style and convenience.\n\nResidents enjoy an array of top-notch amenities that cater to an elevated lifestyle. Keep active in our state-of-the-art fitness center or enjoy a peaceful yoga session in the Peloton studio. After a long day, relax at our rooftop pool or take your furry friend to our outdoor dog park. With Lake Haus, not only do you get a home near M Health Fairview Masonic Children's Hospital, but you also join a community that enriches your lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts near M Health Fairview Masonic Hospital",
      "seo_description": "Lake Haus offers luxury apartments near M Health Fairview Masonic Children's Hospital in Hennepin County. Enjoy top amenities and a perfect location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "apartments-near-minneapolis-sculpture-garden",
      "search_query": "apartments near minneapolis sculpture garden",
      "category": "Park",
      "h1_title": "Apts Near Minneapolis Sculpture Garden",
      "h2_subtitle": "Explore stylish apartments near the Minneapolis Sculpture Garden at Lake Haus. Enjoy art, nature, and modern living combined.",
      "page_copy": "For art enthusiasts and nature lovers looking for apartments near the Minneapolis Sculpture Garden, Lake Haus is the perfect choice. Located in the vibrant Triangle neighborhood, our community offers luxurious living spaces with stunning views of Lake Bde Maka Ska. Our chic one and two-bedroom apartments boast modern finishes such as Moen fixtures and white-wash oak hardwood plank flooring, providing a stylish yet comfortable environment.\n\nEnjoy a wide array of amenities right at your doorstep. Whether it's maintaining a healthy lifestyle at our well-equipped fitness center or taking a swim in the rooftop pool, Lake Haus offers plenty of ways to unwind and relax. Our Peloton cycling and yoga studio provides a convenient way to stay active, while the outdoor dog park is perfect for spending time with your furry friends. With its close proximity to the Minneapolis Sculpture Garden, Lake Haus encapsulates the ideal blend of culture and comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts near Minneapolis Sculpture Garden",
      "seo_description": "Discover Lake Haus for luxury apartments near the Minneapolis Sculpture Garden. Enjoy art, comfort, and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "lake-haus-close-to-centennial-lakes-park",
      "search_query": "lake haus close to centennial lakes park",
      "category": "Park",
      "h1_title": "Lake Haus Near Centennial Lakes Park",
      "h2_subtitle": "Discover Lake Haus, conveniently close to Centennial Lakes Park, offering luxurious living with exceptional amenities and a vibrant community.",
      "page_copy": "If you're seeking a residence that offers both luxury and proximity to the beautiful Centennial Lakes Park, Lake Haus is the perfect fit. Situated in the lively Triangle neighborhood of Minneapolis, Lake Haus provides easy access to the serenity and recreational opportunities at Centennial Lakes Park. Our one and two-bedroom apartments feature elegant designs with modern touches like Moen fixtures and white-wash oak hardwood plank flooring, offering the perfect backdrop for stylish living.\n\nResidents of Lake Haus enjoy an array of premium amenities designed to enhance comfort and community living. Stay active in our state-of-the-art fitness center, unwind in our rooftop pool, or find balance in the Peloton cycling and yoga studio. Our outdoor dog park is great for both play and relaxation with your furry friends. Lake Haus offers not only a vibrant lifestyle but also close connection to the natural beauty of Centennial Lakes Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lake Haus Near Centennial Lakes Park",
      "seo_description": "Explore luxury living at Lake Haus, close to Centennial Lakes Park. Enjoy top amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "living-by-lake-harriet-bandshell-park",
      "search_query": "living by lake harriet bandshell park minneapolis",
      "category": "Park",
      "h1_title": "Living by Lake Harriet Bandshell Park",
      "h2_subtitle": "Experience the charm of living by Lake Harriet Bandshell Park at Lake Haus. Enjoy vibrant Minneapolis life and top-tier amenities.",
      "page_copy": "Discover the unique charm of living by Lake Harriet Bandshell Park with a home at Lake Haus. Located in Minneapolis's Triangle neighborhood, Lake Haus offers easy access to this iconic lakeside spot, known for its scenic beauty and lively cultural events. Our chic one and two-bedroom apartments boast modern amenities, including Moen fixtures and white-wash oak hardwood plank flooring, providing a stylish living environment that complements the vibrant atmosphere of the nearby park.\n\nAt Lake Haus, residents benefit from a host of luxurious amenities designed for comfort and convenience. Maintain an active lifestyle in our state-of-the-art fitness center or find serenity doing yoga in our Peloton studio. Our rooftop pool serves as the perfect escape for relaxation, while the outdoor dog park offers a great way to spend time with your four-legged friends. Lake Haus is ideal for anyone looking to enjoy the best of Minneapolis living, just steps away from the picturesque Lake Harriet Bandshell Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living by Lake Harriet Bandshell Park",
      "seo_description": "Live by Lake Harriet Bandshell Park at Lake Haus. Enjoy modern apartments and amenities close to Minneapolis's iconic lakeside park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "residences-near-boom-island-park-hennepin-county",
      "search_query": "residences near boom island park hennepin county",
      "category": "Park",
      "h1_title": "Residences Near Boom Island Park",
      "h2_subtitle": "Explore luxurious residences near Boom Island Park in Hennepin County. Lake Haus offers modern amenities with nature at your doorstep.",
      "page_copy": "Embrace the tranquility and excitement of living near Boom Island Park in Hennepin County with a residence at Lake Haus. Nestled in the heart of Minneapolis's Triangle neighborhood, Lake Haus provides a perfect blend of urban living and natural beauty. Our stylish one and two-bedroom apartments offer floor-to-ceiling views of Lake Bde Maka Ska, with luxurious modern finishes like Moen fixtures and white-wash oak hardwood plank flooring.\n\nEnjoy unrivaled amenities that cater to an active and comfortable lifestyle. Our state-of-the-art fitness center and Peloton cycling and yoga studio are perfect for staying fit, while the rooftop pool offers a stunning retreat. The outdoor dog park ensures your furry friends feel at home too. With close proximity to Boom Island Park, Lake Haus invites you to explore the best of nature and city life right out of your door.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near Boom Island Park",
      "seo_description": "Discover Lake Haus residences near Boom Island Park in Hennepin County. Enjoy modern amenities and the perfect blend of city and nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "homes-close-to-theodore-wirth-regional-park",
      "search_query": "homes close to theodore wirth regional park triangle",
      "category": "Park",
      "h1_title": "Homes Near Theodore Wirth Regional Park",
      "h2_subtitle": "Discover homes close to Theodore Wirth Regional Park in the Triangle neighborhood. Lake Haus offers luxury living with natural beauty at your doorstep.",
      "page_copy": "Experience the best of both worlds with a home at Lake Haus, located near Theodore Wirth Regional Park in the Triangle neighborhood of Minneapolis. Our community offers stylish one and two-bedroom apartments that promise luxury and comfort, featuring modern finishes such as Moen fixtures and white-wash oak hardwood plank flooring. With expansive views of Lake Bde Maka Ska, you will feel connected to nature right from the comfort of your own home.\n\nLake Haus offers a variety of amenities designed to enhance your lifestyle. Stay active in our state-of-the-art fitness center or unwind in the Peloton cycling and yoga studio. Enjoy warm summer days by our rooftop pool or explore the outdoors with your pet in our spacious dog park. Lake Haus’s proximity to Theodore Wirth Regional Park makes it easy to enjoy hiking, biking, and more, combining urban convenience with outdoor adventure.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Homes Near Theodore Wirth Regional Park",
      "seo_description": "Explore Lake Haus homes close to Theodore Wirth Regional Park in the Triangle. Luxury living with natural beauty awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "apartments-near-east-bank-minneapolis",
      "search_query": "apartments near East Bank Minneapolis",
      "category": "Transit",
      "h1_title": "Apartments Near East Bank Minneapolis",
      "h2_subtitle": "Discover luxury apartments near East Bank Minneapolis at Lake Haus. Enjoy modern living with easy access to dynamic city life.",
      "page_copy": "Lake Haus offers an exceptional living experience with our luxurious apartments near East Bank Minneapolis. Situated in the vibrant Triangle neighborhood, Lake Haus provides effortless access to the bustling urban core while maintaining a serene lakeside setting. Our chic one and two-bedroom layouts feature modern finishes such as Moen fixtures and white-wash oak hardwood flooring, ensuring a stylish and comfortable lifestyle.\n\nResidents at Lake Haus enjoy a wide array of amenities designed for comfort and convenience. Our state-of-the-art fitness center and Peloton cycling and yoga studio cater to health enthusiasts, while the rooftop pool is perfect for relaxation. For pet owners, our outdoor dog park offers a great place for play. With views of Lake Bde Maka Ska and easy access to East Bank, Lake Haus combines urban life with natural beauty, creating the ideal home setting for any renter.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near East Bank Minneapolis",
      "seo_description": "Find luxurious apartments near East Bank Minneapolis at Lake Haus. Enjoy modern amenities and a vibrant lifestyle in an ideal location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "luxury-apartments-near-warehouse-district-hennepin-ave",
      "search_query": "luxury apartments near Warehouse District Hennepin Ave",
      "category": "Transit",
      "h1_title": "Luxury Apartments by Warehouse District",
      "h2_subtitle": "Explore luxury apartments near Warehouse District Hennepin Ave. Experience upscale living at Lake Haus with stunning views and premium amenities.",
      "page_copy": "Discover unparalleled luxury living near the Warehouse District and Hennepin Ave at Lake Haus. Located in Minneapolis’s trendy Triangle neighborhood, Lake Haus combines the excitement of urban life with a serene setting by Lake Bde Maka Ska. Our upscale one and two-bedroom apartments boast modern features like Moen fixtures, white-wash oak hardwood plank flooring, and expansive lake views, offering the epitome of comfort and style.\n\nResidents enjoy top-tier amenities designed for a sophisticated lifestyle. Stay fit in our state-of-the-art fitness center or unwind in the Peloton cycling and yoga studio. The rooftop pool offers a relaxing escape, while our outdoor dog park ensures fun for your four-legged friends. With Lake Haus just a stone's throw away from the dynamic Warehouse District and Hennepin Ave, you’ll love having entertainment and dining options at your fingertips.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments by Warehouse District",
      "seo_description": "Find luxury apartments near Warehouse District Hennepin Ave at Lake Haus. Enjoy upscale living with modern amenities and stunning lake views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "lake-haus-apartments-by-nicollet-mall",
      "search_query": "Lake Haus apartments by Nicollet Mall",
      "category": "Transit",
      "h1_title": "Lake Haus Apartments Near Nicollet Mall",
      "h2_subtitle": "Discover Lake Haus apartments by Nicollet Mall in Minneapolis. Experience modern living with premium amenities just steps from urban conveniences.",
      "page_copy": "Nestled in the heart of Minneapolis, Lake Haus offers luxurious apartments by Nicollet Mall, perfectly blending modern living with vibrant city life. Located in the Triangle neighborhood, our one and two-bedroom apartments feature contemporary amenities such as Moen fixtures and white-wash oak hardwood plank flooring, providing you with a sophisticated and comfortable living environment.\n\nEnjoy an active lifestyle with Lake Haus’s state-of-the-art amenities, including a rooftop pool, a fitness center, and a Peloton cycling and yoga studio. Our outdoor dog park is the ideal spot for pet owners to unwind with their four-legged companions. With Nicollet Mall just moments away, residents of Lake Haus can enjoy a vast array of dining, shopping, and entertainment options, ensuring there's always something exciting to do right at your doorstep.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lake Haus Apartments Near Nicollet Mall",
      "seo_description": "Explore Lake Haus apartments near Nicollet Mall. Experience luxurious living with modern features and easy access to city attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166132",
      "source": "generator",
      "page_item_url": "triangle-neighborhood-apartments-near-government-plaza",
      "search_query": "Triangle neighborhood apartments near Government Plaza",
      "category": "Transit",
      "h1_title": "Triangle Apartments Near Government Plaza",
      "h2_subtitle": "Discover stylish Triangle neighborhood apartments near Government Plaza. Lake Haus offers modern amenities and easy access to downtown Minneapolis.",
      "page_copy": "Located in the vibrant Triangle neighborhood, Lake Haus provides exquisite apartments near Government Plaza, perfect for those seeking a blend of modern living and urban accessibility. Our stylish one and two-bedroom apartments boast high-end features, including Moen fixtures and white-wash oak hardwood flooring, with breathtaking views of Lake Bde Maka Ska.\n\nLake Haus is more than just an apartment complex; it's a lively community with top-tier amenities designed for a refined lifestyle. Residents can enjoy our state-of-the-art fitness center and relax by the rooftop pool. The on-site Peloton cycling and yoga studio offers a perfect way to unwind. Plus, the outdoor dog park is a fantastic bonus for pet owners. With Government Plaza just a short journey away, Lake Haus is ideal for those wanting a convenient commute alongside luxurious living in the Triangle neighborhood.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Triangle Apartments Near Government Plaza",
      "seo_description": "Find Triangle neighborhood apartments near Government Plaza at Lake Haus. Enjoy modern amenities and easy downtown access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "1458"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9569214246"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6128000561"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PP768GHV"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 6"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "9dab949c-c767-4bac-bb40-a118a92546b2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Oasis"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/6c05f253-2cca-41ea-ace6-2d7667bd296d/app.js?property=6c05f253-2cca-41ea-ace6-2d7667bd296d&propertyName=LakeHaus&channelUuid=ca7bebfc-6985-11f0-8a1c-42010aa8d42b\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_cort_lead_form_id",
      "type": "STRING",
      "value": "Lakehaus_kRDWXvjtyZEK1mZsmign"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "4325685550"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/r5v5670zpny"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IktSd1dOdDBJNmFDbU1oQUpGSVRXY0E9PSIsInZhbHVlIjoibitlaW82em9XWnhDNFRVcE9iVFg3UT09IiwibWFjIjoiNTFkZTg2NmU3ZWUzMGYxODQ4OTZkNjFiMmIzYjBiYWQ4NDc1MmI0OTY3NTFmMTk3M2IxMTU3YjhiMzA1Y2Q0YyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "1458",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9569214246",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6128000561",
  "custom_google_gtm_id": "GTM-PP768GHV",
  "custom_rollout_phase": "Phase 6",
  "custom_rentgrata_token": "9dab949c-c767-4bac-bb40-a118a92546b2",
  "custom_vibesites_theme": "Oasis",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/6c05f253-2cca-41ea-ace6-2d7667bd296d/app.js?property=6c05f253-2cca-41ea-ace6-2d7667bd296d&propertyName=LakeHaus&channelUuid=ca7bebfc-6985-11f0-8a1c-42010aa8d42b\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_cort_lead_form_id": "Lakehaus_kRDWXvjtyZEK1mZsmign",
  "custom_hubspot_company_id": "4325685550",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/r5v5670zpny",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IktSd1dOdDBJNmFDbU1oQUpGSVRXY0E9PSIsInZhbHVlIjoibitlaW82em9XWnhDNFRVcE9iVFg3UT09IiwibWFjIjoiNTFkZTg2NmU3ZWUzMGYxODQ4OTZkNjFiMmIzYjBiYWQ4NDc1MmI0OTY3NTFmMTk3M2IxMTU3YjhiMzA1Y2Q0YyJ9",
  "custom_audioeye_site_id": "9352b7c3-1584-43a4-ac38-e5321010e9e0",
  "custom_audioeye_site_hash": "4b6c8f62a5486f75b568007978b9394b"
};

export const generatedAt = '2026-11-03T17:58:30.119Z';
